/* ════════════════════════════════════════════════════════════════════════════
   tn-app.js — /tinnitus-notch: прибор «звуки от шума в ушах с нотчем».

   Устройство:
     • математика (нотч, окраска, шум, анализ) — tn-dsp.js, одна для графика,
       живого звука и файла;
     • живой граф: источник → [секции IIRFilterNode] → компенсация → громкость →
       плавное затухание → скрытый <audio> (фон и экран блокировки);
     • смена частоты или ширины — новая цепочка и перекрёстное затухание 40 мс:
       у IIRFilterNode коэффициенты неизменяемы, а щелчок при перетаскивании
       ручки недопустим;
     • тон для подбора — отдельный контекст с обычной задержкой: ползунок
       должен звучать сразу, а у сеанса прослушивания — «playback» ради батареи.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
'use strict';

var CFG = window.TN_CFG || {};
var T = CFG.t || {};
var SLUG = 'tinnitus-notch';
var DSP = window.TinnitusDSP;
var DK = window.DeviceKit;
if (!DSP || !document.getElementById('tnConsole')) return;

var LOCALE = CFG.locale || document.documentElement.lang || 'en';
var FMIN = 150, FMAX = 16000;            // диапазон, который предлагает прибор
var XMIN = 100, XMAX = 20000;            // ось графика
/* Цифры — латинские в любой локали: у арабской Intl по умолчанию печатает
   «٤٠٠٠», и поле частоты перестало бы разбирать собственное значение. */
var NF;
try { NF = new Intl.NumberFormat(LOCALE + '-u-nu-latn', { maximumFractionDigits: 0 }); } catch (e) { NF = { format: function (n) { return String(Math.round(n)); } }; }
var NF1;
try { NF1 = new Intl.NumberFormat(LOCALE + '-u-nu-latn', { maximumFractionDigits: 1 }); } catch (e) { NF1 = { format: function (n) { return String(Math.round(n * 10) / 10); } }; }

function t(k, r) {
    var s = T[k] != null ? String(T[k]) : k;
    if (r) Object.keys(r).forEach(function (n) { s = s.split(':' + n).join(String(r[n])); });
    return s;
}
function $(id) { return document.getElementById(id); }
function hz(f) { return NF.format(Math.round(f)); }
function clampF(f) { return Math.max(FMIN, Math.min(FMAX, f)); }
function toast(m, type) { try { if (window.__toast) window.__toast(m, type || 'info'); } catch (e) { } }
function feat(f, p) { try { if (window.__aeFeature) window.__aeFeature(f, p || {}); } catch (e) { } }
function funnel(stage, p) { try { if (window.__aeFunnel) window.__aeFunnel(stage, p || {}); } catch (e) { } }
function stage(name, p) { try { if (window.__stage) window.__stage(name, p || {}); } catch (e) { } }
function isPro() { try { return DK ? DK.isPro() : !!(window.__isProNow && window.__isProNow(false)); } catch (e) { return false; } }
function nowMs() { try { if (window.__activeNow) return window.__activeNow(); } catch (e) { } return performance.now(); }
function icon(n) { return DK ? DK.icon(n) : ''; }

/* ── хранение ────────────────────────────────────────────────────────────── */
var TS = window.__toolSettings || { load: function (a, b, c) { return c; }, save: function () { } };
var DEF = {
    f: 4000, f2: 0, two: false, w: 'auto', edge: false, edgeDb: 10, tilt: false,
    src: 'pink', vol: 45, timer: 0, goal: 120, ear: 'B', stim: 'tone', toneVol: 30, matched: false
};
var S = Object.assign({}, DEF, TS.load(SLUG, 'profile', {}) || {});
var MATCHES = TS.load(SLUG, 'matches', []) || [];
var LOG = TS.load(SLUG, 'log', null) || { days: {}, first: null };
if (!LOG.days) LOG.days = {};

/* Профиль прежней версии тула (до 29.09.2026) — переносим, чтобы подобранная
   частота и накопленные часы не пропали. */
(function migrate() {
    try {
        var old = JSON.parse(localStorage.getItem('tmb:tinnitus:profile') || 'null');
        if (old && old.freq && !TS.load(SLUG, 'profile', null)) {
            S.f = clampF(+old.freq || 4000); S.matched = true;
            S.w = old.width === 'one' ? '1' : old.width === 'half' ? '0.5' : 'auto';
            S.edge = !!old.edge;
        }
        var hours = parseFloat(localStorage.getItem('tmb:tinnitus:hours') || '0');
        if (hours > 0 && !LOG.legacyMin) { LOG.legacyMin = Math.round(hours * 60); }
        localStorage.removeItem('tmb:tinnitus:profile');
        localStorage.removeItem('tmb:tinnitus:hours');
    } catch (e) { }
})();

function saveProfile() { TS.save(SLUG, 'profile', S); }
function saveMatches() { TS.save(SLUG, 'matches', MATCHES.slice(-24)); }
function saveLog() { TS.save(SLUG, 'log', LOG); }

function dayKey(d) {
    d = d || new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
function dayRec(k) { k = k || dayKey(); if (!LOG.days[k]) LOG.days[k] = { m: 0 }; return LOG.days[k]; }

/* Ссылка с настройками: #f=6000&w=0.5&e=10&t=1&f2=3000 — врач или сам человек
   переносит профиль на другое устройство без аккаунта. */
(function fromHash() {
    try {
        var h = location.hash.replace(/^#/, '');
        if (!/(^|&)f=\d/.test(h)) return;
        var p = new URLSearchParams(h);
        var f = +p.get('f');
        if (f > 0) { S.f = clampF(f); S.matched = true; }
        var w = p.get('w');
        if (w && /^(auto|0\.5|1|1\.5)$/.test(w)) S.w = w;
        var e = +p.get('e');
        if (e > 0) { S.edge = true; S.edgeDb = Math.max(3, Math.min(20, e)); } else if (p.has('e')) S.edge = false;
        if (p.has('t')) S.tilt = p.get('t') === '1';
        var f2 = +p.get('f2');
        if (f2 > 0) { S.f2 = clampF(f2); S.two = true; }
        saveProfile();
        setTimeout(function () { toast(t('from_link'), 'success'); }, 600);
        feat('share_open', {});
    } catch (e) { }
})();

/* ── производные: ширина, профиль фильтра ────────────────────────────────── */
function summary() { return DSP.matchSummary(recentMatches()); }
function recentMatches() {
    var cut = Date.now() - 60 * 86400000;
    return MATCHES.filter(function (m) { return (m.t || 0) >= cut; }).slice(-6);
}
function widthOct() {
    if (S.w !== 'auto') return +S.w;
    var s = summary();
    return s ? s.autoW : 1;
}
function notchList() {
    var W = widthOct(), list = [{ f0: S.f, W: W }];
    if (S.two && S.f2 > 0 && isPro()) list.push({ f0: S.f2, W: W });
    return list;
}
function designFor(sr) {
    return DSP.designChain({ notches: notchList(), edgeDb: S.edge ? S.edgeDb : 0, tilt: S.tilt }, sr);
}

/* ═══ ЗВУК ═══════════════════════════════════════════════════════════════ */
var AC = null;          // контекст сеанса прослушивания
var G = null;           // граф сеанса
var PLAY = { on: false, kind: null, started: 0, lastTick: 0, sessionMin: 0, completeSent: false, endAt: 0, sys: false };
var NOISE_CACHE = {};
var PROFILES = {};      // спектры источников: 'pink'|'brown'|'white' → profile

function makeCtx() {
    var C = window.AudioContext || window.webkitAudioContext;
    try { return new C({ latencyHint: 'playback' }); } catch (e) { return new C(); }
}
function claimSession() {
    /* Safari: «playback» — звук идёт мимо беззвучного режима и не глохнет с
       блокировкой экрана (iOS 17.5+). В остальных браузерах свойства нет. */
    try { if (navigator.audioSession && navigator.audioSession.type !== 'playback') navigator.audioSession.type = 'playback'; } catch (e) { }
}

function ensureGraph() {
    if (!AC) {
        AC = makeCtx();
        AC.onstatechange = onCtxState;
    }
    if (G && G.ctx === AC) return G;
    var c = AC;
    G = { ctx: c, chain: null, design: null };
    G.pre = c.createGain();
    G.anPre = c.createAnalyser(); G.anPre.fftSize = 8192; G.anPre.smoothingTimeConstant = 0.86;
    G.makeup = c.createGain();
    G.anPost = c.createAnalyser(); G.anPost.fftSize = 8192; G.anPost.smoothingTimeConstant = 0.86;
    G.vol = c.createGain();
    G.fade = c.createGain(); G.fade.gain.value = 0;
    G.pre.connect(G.anPre);
    G.makeup.connect(G.anPost);
    G.anPost.connect(G.vol);
    G.vol.connect(G.fade);
    G.route = null;
    setVolume();
    applyDesign(true);
    return G;
}

/* Выход через скрытый <audio>: вкладка, играющая медиа, получает от браузера
   «полное медийное обращение» — не засыпает в фоне, управление на экране
   блокировки, iOS не глушит звук с погасшим экраном. Зовётся из жеста. */
function attachOutput() {
    if (G.route || G.direct) return;
    var r = null;
    try { r = window.__audioBackground && window.__audioBackground.routeToElement(AC, G.fade); } catch (e) { r = null; }
    if (r && r.ok) { G.route = r; }
    else { G.fade.connect(AC.destination); G.direct = true; feat('bg_route_fallback', {}); }
}

function iirSupported(c) { return typeof c.createIIRFilter === 'function'; }

/* Без IIRFilterNode (Safari до 14.1) — приближение штатными биквадами:
   три режекции на полосу и тот же подъём краёв. График рисует ИМЕННО это
   приближение: коэффициенты считаются по тем же формулам спецификации. */
function notchBq(fc, Q, fs) {
    var w0 = 2 * Math.PI * fc / fs, al = Math.sin(w0) / (2 * Q), c = Math.cos(w0), a0 = 1 + al;
    return [1 / a0, -2 * c / a0, 1 / a0, 1, -2 * c / a0, (1 - al) / a0];
}
function approxDesign(d, fs) {
    var sos = [], plan = [];
    d.bands.forEach(function (b) {
        var W = Math.log(b.fh / b.fl) / Math.LN2;
        [-W / 3, 0, W / 3].forEach(function (o) {
            var fc = b.f0 * Math.pow(2, o), Q = 2.2 * fc / (b.fh - b.fl);
            sos.push(notchBq(fc, Q, fs)); plan.push({ type: 'notch', f: fc, Q: Q });
        });
    });
    d.colorSos.forEach(function (s) { sos.push(s); plan.push({ type: 'sos', s: s }); });
    return { sos: sos, plan: plan, bands: d.bands, colorSos: d.colorSos, approx: true };
}

function buildChain(c, d) {
    var input = c.createGain(), output = c.createGain(), nodes = [], prev = input;
    if (iirSupported(c)) {
        d.sos.forEach(function (s) {
            var n = c.createIIRFilter([s[0], s[1], s[2]], [1, s[4], s[5]]);
            prev.connect(n); prev = n; nodes.push(n);
        });
    } else {
        (d.plan || []).forEach(function (p) {
            var n = c.createBiquadFilter();
            if (p.type === 'notch') { n.type = 'notch'; n.frequency.value = p.f; n.Q.value = p.Q; }
            else { n = c.createIIRFilter ? c.createIIRFilter([p.s[0], p.s[1], p.s[2]], [1, p.s[4], p.s[5]]) : n; }
            prev.connect(n); prev = n; nodes.push(n);
        });
    }
    prev.connect(output);
    return { input: input, output: output, nodes: nodes };
}

var designTimer = 0, designLast = 0;
function scheduleDesign() {
    var now = performance.now();
    if (now - designLast > 70) { designLast = now; applyDesign(); return; }
    clearTimeout(designTimer);
    designTimer = setTimeout(function () { designLast = performance.now(); applyDesign(); }, 75);
}
function applyDesign(initial) {
    if (!G) { drawAll(); return; }
    var c = G.ctx, d = designFor(c.sampleRate);
    if (!iirSupported(c)) d = approxDesign(d, c.sampleRate);
    var nc = buildChain(c, d), now = c.currentTime;
    G.pre.connect(nc.input);
    nc.output.connect(G.makeup);
    if (initial || !G.chain) {
        nc.output.gain.value = 1;
    } else {
        var old = G.chain;
        nc.output.gain.setValueAtTime(0, now);
        nc.output.gain.linearRampToValueAtTime(1, now + 0.04);
        old.output.gain.setValueAtTime(old.output.gain.value, now);
        old.output.gain.linearRampToValueAtTime(0, now + 0.04);
        setTimeout(function () {
            try { G.pre.disconnect(old.input); } catch (e) { }
            try { old.output.disconnect(); } catch (e) { }
            old.nodes.forEach(function (n) { try { n.disconnect(); } catch (e) { } });
        }, 140);
    }
    G.chain = nc;
    G.design = d;
    setMakeup();
    drawAll();
}
function setMakeup() {
    if (!G) return;
    var db = DSP.makeupDb(G.design ? G.design.colorSos : [], currentProfile(), G.ctx.sampleRate);
    G.makeup.gain.setTargetAtTime(Math.pow(10, db / 20), G.ctx.currentTime, 0.03);
}
function setVolume() {
    if (!G) return;
    /* Ползунок в «слуховой» шкале: квадрат даёт равные шаги громкости. */
    var v = S.vol / 100;
    G.vol.gain.setTargetAtTime(v * v * 1.6, G.ctx.currentTime, 0.03);
}

/* ── источники ───────────────────────────────────────────────────────────── */
function loopBuffer(c, type, seconds, seed) {
    var sr = c.sampleRate, L = Math.round(seconds * sr), X = Math.round(1.5 * sr);
    var buf = c.createBuffer(2, L, sr);
    for (var ch = 0; ch < 2; ch++) {
        var tmp = new Float32Array(L + X);
        DSP.noiseGen(type, seed + ch * 7919).fill(tmp);
        var out = buf.getChannelData(ch);
        out.set(tmp.subarray(0, L));
        /* Шов петли: хвост переходит в начало с равной мощностью — щелчка на
           повторе нет, а две петли разной длины не совпадают годами. */
        for (var i = 0; i < X; i++) {
            var p = i / X, a = Math.sin(p * Math.PI / 2), b = Math.cos(p * Math.PI / 2);
            out[i] = a * tmp[i] + b * tmp[L + i];
        }
    }
    return buf;
}
function noiseBuffers(c, type) {
    var k = type + ':' + c.sampleRate;
    if (!NOISE_CACHE[k]) NOISE_CACHE[k] = [loopBuffer(c, type, 17.3, 101), loopBuffer(c, type, 23.9, 977)];
    return NOISE_CACHE[k];
}
function startNoise(type) {
    var c = G.ctx, bufs = noiseBuffers(c, type), g = c.createGain();
    g.gain.value = Math.SQRT1_2;
    var a = c.createBufferSource(), b = c.createBufferSource();
    a.buffer = bufs[0]; b.buffer = bufs[1]; a.loop = b.loop = true;
    a.connect(g); b.connect(g); g.connect(G.pre);
    a.start(); b.start(c.currentTime, Math.random() * bufs[1].duration);
    return { stop: function () { [a, b].forEach(function (s) { try { s.stop(); } catch (e) { } try { s.disconnect(); } catch (e) { } }); try { g.disconnect(); } catch (e) { } } };
}
function noiseProfile(type) {
    if (PROFILES[type]) return PROFILES[type];
    var sr = AC ? AC.sampleRate : 48000, x = new Float32Array(sr * 6);
    DSP.noiseGen(type, 5).fill(x);
    PROFILES[type] = DSP.spectrumProfile([x], sr, 140);
    return PROFILES[type];
}

/* Музыка играет через <audio> (браузер декодирует потоком: час микса не ляжет
   в память целиком), а спектр для оценки «хватает ли энергии» считается
   отдельно — декодом до 40 МБ, живым анализатором для больших файлов. */
var TRACKS = [];         // {id, file, name, url, profile, grade, live}
var CUR = 0;
function mediaFor(c) {
    if (G.media && G.media.ctx === c) return G.media;
    var el = document.createElement('audio');
    el.preload = 'auto';
    el.setAttribute('aria-hidden', 'true');
    var src = c.createMediaElementSource(el);
    src.connect(G.pre);
    el.addEventListener('ended', function () { if (PLAY.on && PLAY.kind === 'music') nextTrack(1, true); });
    el.addEventListener('error', function () {
        if (!PLAY.on || PLAY.kind !== 'music') return;
        toast(t('err_track_play'), 'error');
        feat('track_play_error', { code: el.error ? el.error.code : 0 });
        nextTrack(1, true);
    });
    G.media = { ctx: c, el: el, src: src };
    return G.media;
}

/* ── вкладка браузера (Премиум) ──────────────────────────────────────────── */
var TAB = null;
function tabSupported() {
    try {
        return !!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia &&
            navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().suppressLocalAudioPlayback) &&
            !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    } catch (e) { return false; }
}
function pickTab() {
    if (!isPro()) { upsell('tab'); return; }
    var p;
    try {
        p = navigator.mediaDevices.getDisplayMedia({
            video: { displaySurface: 'browser' },
            audio: { suppressLocalAudioPlayback: true, echoCancellation: false, noiseSuppression: false, autoGainControl: false },
            preferCurrentTab: false, selfBrowserSurface: 'exclude', surfaceSwitching: 'include', systemAudio: 'exclude'
        });
    } catch (e) { toast(t('tab_fail'), 'error'); return; }
    p.then(function (stream) {
        stream.getVideoTracks().forEach(function (tr) { tr.stop(); });
        var au = stream.getAudioTracks()[0];
        if (!au) { toast(t('tab_no_audio'), 'warning'); return; }
        if (TAB) stopTab();
        TAB = { stream: stream, track: au };
        au.addEventListener('ended', function () { if (PLAY.kind === 'tab') stopPlay('tab_ended'); stopTab(); renderSound(); });
        setSource('tab');
        startPlay();
        feat('tab_notch_start', {});
    }).catch(function (e) {
        if (e && e.name === 'NotAllowedError') return;
        toast(t('tab_fail'), 'error');
        feat('tab_notch_fail', { err: String(e && e.name || e).slice(0, 40) });
    });
}
function stopTab() {
    if (!TAB) return;
    try { TAB.stream.getTracks().forEach(function (tr) { tr.stop(); }); } catch (e) { }
    if (TAB.node) { try { TAB.node.disconnect(); } catch (e) { } }
    TAB = null;
}

/* ── воспроизведение ─────────────────────────────────────────────────────── */
var SRC_NODE = null;
/* Источник запускается отдельно от выхода: смена «шум → музыка» на ходу
   меняет только его, а скрытый <audio> выхода продолжает играть. Пауза и
   повторный play() выхода вне жеста на iPhone отклоняются. */
function startSource(kind) {
    var c = G.ctx;
    /* Всё, что требует жеста (play() у медиа), — синхронно, до любых await. */
    if (kind === 'music') {
        if (!TRACKS.length) { openSection('sound'); toast(t('need_tracks'), 'warning'); return false; }
        var m = mediaFor(c), tr = TRACKS[CUR] || TRACKS[0];
        if (m.el.src !== tr.url) m.el.src = tr.url;
        var pp = m.el.play();
        if (pp && pp.catch) pp.catch(function (e) { if (e && e.name === 'NotAllowedError') { stopPlay('blocked'); toast(t('err_blocked'), 'warning'); } });
        SRC_NODE = { stop: function () { try { m.el.pause(); } catch (e) { } } };
        liveAnalyse(tr);
    } else if (kind === 'tab') {
        if (!TAB) { pickTab(); return false; }
        TAB.node = c.createMediaStreamSource(new MediaStream([TAB.track]));
        TAB.node.connect(G.pre);
        SRC_NODE = { stop: function () { try { TAB.node.disconnect(); } catch (e) { } } };
    } else {
        SRC_NODE = startNoise(kind);
    }
    return true;
}
function swapSource(kind) {
    var old = SRC_NODE; SRC_NODE = null;
    if (old) old.stop();
    if (!startSource(kind)) { stopPlay('switch'); return; }
    PLAY.kind = kind;
    mediaSession(true);
    renderPlay();
    feat('play_' + kind, { f: S.f, live_switch: 1 });
}
function startPlay() {
    toneStop();
    claimSession();
    ensureGraph();
    attachOutput();
    var c = G.ctx, kind = S.src;
    if (!startSource(kind)) return;
    if (G.route) G.route.resume();
    try { if (c.state !== 'running') c.resume(); } catch (e) { }
    var now = c.currentTime;
    G.fade.gain.cancelScheduledValues(now);
    G.fade.gain.setValueAtTime(G.fade.gain.value, now);
    G.fade.gain.linearRampToValueAtTime(1, now + 1.2);
    PLAY.on = true; PLAY.kind = kind; PLAY.started = nowMs(); PLAY.lastTick = PLAY.started; PLAY.sys = false;
    PLAY.endAt = S.timer > 0 ? Date.now() + S.timer * 60000 : 0;
    if (S.timer > 0) {
        /* Затухание назначаем часам аудиопотока: в фоне таймеры страницы
           засыпают, а звук — нет. */
        var end = now + S.timer * 60;
        G.fade.gain.setValueAtTime(1, end - 20);
        G.fade.gain.linearRampToValueAtTime(0, end);
    }
    /* Живой контекст — после жеста: если устройство вывода умерло, прежний
       контекст не оживёт, и граф надо пересобрать на новом. */
    if (window.__liveAudioCtxReady) {
        window.__liveAudioCtxReady(AC, makeCtx).then(function (live) {
            if (live && live !== AC) {
                AC = live; AC.onstatechange = onCtxState; G = null;
                if (PLAY.on) { PLAY.on = false; startPlay(); }
            }
        }).catch(function () { stopPlay('ctx_dead'); toast(t('err_audio'), 'error'); });
    }
    mediaSession(true);
    renderPlay();
    stage('play', { src: kind });
    feat('play_' + kind, { f: S.f, w: widthOct(), edge: S.edge ? S.edgeDb : 0, tilt: S.tilt ? 1 : 0 });
    loop();
}
function stopPlay(why) {
    if (!PLAY.on) return;
    tickListen(true);
    PLAY.on = false;
    var c = G && G.ctx;
    if (c) {
        var now = c.currentTime;
        G.fade.gain.cancelScheduledValues(now);
        G.fade.gain.setValueAtTime(G.fade.gain.value, now);
        G.fade.gain.linearRampToValueAtTime(0, now + 0.25);
    }
    var s = SRC_NODE; SRC_NODE = null;
    setTimeout(function () { if (s) s.stop(); if (!PLAY.on && G && G.route) G.route.pause(); }, 300);
    mediaSession(false);
    renderPlay();
    if (why && why !== 'user') feat('play_stop', { why: why });
}
function togglePlay() { if (PLAY.on) stopPlay('user'); else startPlay(); }

function onCtxState() {
    if (!AC) return;
    var st = AC.state;
    /* hidden и as — замер 09.10.2026: «playback» + вывод через <audio> обещали
       звук с погасшим экраном (iOS 17.5+), а единственная iPhone-сессия со
       звуком кончилась ctx_interrupted. Без флагов не отличить блокировку
       экрана от звонка или закрытия вкладки. */
    if (PLAY.on && (st === 'interrupted' || st === 'suspended')) {
        PLAY.sys = true; renderPlay();
        var as = ''; try { as = navigator.audioSession ? String(navigator.audioSession.type) : ''; } catch (e) { }
        feat('ctx_' + st, { hidden: document.hidden ? 1 : 0, as: as, routed: G && G.route ? 1 : 0, min: Math.round(PLAY.sessionMin) });
    }
    else if (PLAY.on && st === 'running' && PLAY.sys) { PLAY.sys = false; PLAY.lastTick = nowMs(); renderPlay(); }
}

function nextTrack(dir, auto) {
    if (!TRACKS.length) return;
    CUR = (CUR + dir + TRACKS.length) % TRACKS.length;
    renderList();
    if (PLAY.on && PLAY.kind === 'music') {
        var m = mediaFor(G.ctx), tr = TRACKS[CUR];
        m.el.src = tr.url;
        var p = m.el.play(); if (p && p.catch) p.catch(function () { });
        liveAnalyse(tr);
        mediaSession(true);
    }
    updateGrade();
    if (!auto) feat('track_skip', {});
}

/* ── экран блокировки ────────────────────────────────────────────────────── */
function mediaSession(on) {
    if (!('mediaSession' in navigator)) return;
    var ms = navigator.mediaSession;
    try {
        if (!on) { ms.playbackState = 'paused'; return; }
        var src = S.src === 'music' && TRACKS[CUR] ? TRACKS[CUR].name : t('src_' + S.src);
        ms.metadata = new window.MediaMetadata({ title: t('ms_title', { f: hz(S.f) }), artist: src, album: CFG.brand || '' });
        ms.playbackState = 'playing';
        var h = {
            play: function () { if (!PLAY.on) startPlay(); },
            pause: function () { if (PLAY.on) stopPlay('lock_screen'); },
            stop: function () { if (PLAY.on) stopPlay('lock_screen'); },
            nexttrack: S.src === 'music' && TRACKS.length > 1 ? function () { nextTrack(1); } : null,
            previoustrack: S.src === 'music' && TRACKS.length > 1 ? function () { nextTrack(-1); } : null
        };
        Object.keys(h).forEach(function (a) { try { ms.setActionHandler(a, h[a]); } catch (e) { } });
        if (S.timer > 0 && ms.setPositionState) {
            ms.setPositionState({ duration: S.timer * 60, position: Math.min(S.timer * 60, (nowMs() - PLAY.started) / 1000), playbackRate: 1 });
        }
    } catch (e) { }
}

/* ── учёт прослушивания ──────────────────────────────────────────────────── */
/* Только считает минуты — ничего не останавливает. stopPlay() начинается с
   tickListen(true), и проверка таймера здесь замыкала круг stopPlay → tickListen →
   stopPlay до переполнения стека: остановка не завершалась, «Стоп» падал туда же
   (Sentry TIMBRICA-FRONTEND-NC/NB, 01.10). Решение «пора остановить» — в тике ниже. */
function tickListen(flush) {
    if (!PLAY.on) return;
    var now = nowMs(), dt = now - PLAY.lastTick;
    PLAY.lastTick = now;
    /* После конца таймера звук уже затух на часах аудиопотока — это не прослушивание. */
    var audible = !PLAY.sys && !timerDue() && (!G || G.ctx.state === 'running') &&
        !(PLAY.kind === 'music' && G && G.media && G.media.el.paused);
    if (audible && dt > 0 && dt < 10 * 60000) {
        var rec = dayRec();
        rec.m = (rec.m || 0) + dt / 60000;
        PLAY.sessionMin += dt / 60000;
        if (!LOG.first) LOG.first = dayKey();
    }
    if (!PLAY.completeSent && PLAY.sessionMin >= 5) {
        PLAY.completeSent = true;
        try { if (window.__aeToolComplete) window.__aeToolComplete({ kind: 'listen', src: PLAY.kind, f: S.f, w: widthOct() }); } catch (e) { }
    }
    if (flush || Math.random() < 0.1) saveLog();
}
function timerDue() { return !!PLAY.endAt && Date.now() >= PLAY.endAt; }
setInterval(function () {
    if (!PLAY.on) return;
    tickListen(false);
    if (timerDue()) { stopPlay('timer'); toast(t('timer_done'), 'success'); }
    renderProgress(); renderClock();
}, 1000);
/* bg_return — замер фона (09.10.2026): сколько вкладка была скрыта, пока
   звук играл, и остановила ли его система. Пара к ctx_interrupted{hidden}. */
var BG = null;
document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
        tickListen(true); saveLog();
        BG = PLAY.on ? { at: Date.now(), sys: PLAY.sys } : null;
        return;
    }
    if (BG) {
        var as = ''; try { as = navigator.audioSession ? String(navigator.audioSession.type) : ''; } catch (e) { }
        feat('bg_return', { ms: Math.max(0, Date.now() - BG.at), sys: (BG.sys || PLAY.sys) ? 1 : 0, ctx: AC ? AC.state : '', as: as, routed: G && G.route ? 1 : 0 });
        BG = null;
    }
    renderProgress(); loop();
});
window.addEventListener('pagehide', function () { tickListen(true); saveLog(); });

/* ═══ ТОН ДЛЯ ПОДБОРА ═══════════════════════════════════════════════════ */
var TC = null, TN = null;
function toneCtx() {
    var C = window.AudioContext || window.webkitAudioContext;
    if (!TC || TC.state === 'closed') TC = new C();
    try { if (TC.state !== 'running') TC.resume(); } catch (e) { }
    return TC;
}
function toneGainFor(f, vol) {
    /* База тише шкалы сеанса: тон узкий и режет слух сильнее шума. Поправка
       на изофону держит громкость ровной при прокрутке частоты. */
    var g = (vol / 100) * (vol / 100) * 0.3 * Math.pow(10, DSP.loudnessCompDb(f) / 20);
    return Math.min(0.5, g);
}
function toneStart(f, opts) {
    opts = opts || {};
    claimSession();
    if (PLAY.on) stopPlay('tone');
    var c = toneCtx();
    toneStop(true);
    var stim = opts.stim || S.stim, ear = opts.ear || S.ear, vol = opts.vol != null ? opts.vol : S.toneVol;
    var out = c.createGain(); out.gain.value = 0;
    var pan = c.createStereoPanner ? c.createStereoPanner() : null;
    if (pan) { pan.pan.value = ear === 'L' ? -1 : ear === 'R' ? 1 : 0; out.connect(pan); pan.connect(c.destination); }
    else out.connect(c.destination);
    var node, bp1 = null, bp2 = null;
    if (stim === 'nbn') {
        /* Узкая полоса шума шириной ⅓ октавы: у шипящего звона она совпадает
           лучше тона, и повторы расходятся меньше (Korth 2021). */
        var buf = c.createBuffer(1, c.sampleRate * 2, c.sampleRate), d = buf.getChannelData(0);
        DSP.noiseGen('white', 29).fill(d);
        node = c.createBufferSource(); node.buffer = buf; node.loop = true;
        bp1 = c.createBiquadFilter(); bp2 = c.createBiquadFilter();
        bp1.type = bp2.type = 'bandpass'; bp1.Q.value = bp2.Q.value = DSP.qFromOct(1 / 3);
        bp1.frequency.value = bp2.frequency.value = f;
        node.connect(bp1); bp1.connect(bp2); bp2.connect(out);
    } else {
        node = c.createOscillator(); node.type = 'sine'; node.frequency.value = f;
        node.connect(out);
    }
    node.start();
    var g = toneGainFor(f, vol) * (stim === 'nbn' ? 2.2 : 1);
    out.gain.setTargetAtTime(g, c.currentTime, 0.04);
    TN = { ctx: c, node: node, out: out, pan: pan, bp1: bp1, bp2: bp2, stim: stim, vol: vol, f: f };
    renderTone();
    return TN;
}
function toneSet(f, vol) {
    if (!TN) return;
    var c = TN.ctx, now = c.currentTime;
    if (vol != null) TN.vol = vol;
    TN.f = f;
    if (TN.stim === 'nbn') { TN.bp1.frequency.setTargetAtTime(f, now, 0.012); TN.bp2.frequency.setTargetAtTime(f, now, 0.012); }
    else TN.node.frequency.setTargetAtTime(f, now, 0.012);
    TN.out.gain.setTargetAtTime(toneGainFor(f, TN.vol) * (TN.stim === 'nbn' ? 2.2 : 1), now, 0.03);
}
function toneStop(quiet) {
    if (!TN) return;
    var n = TN; TN = null;
    try {
        n.out.gain.setTargetAtTime(0, n.ctx.currentTime, 0.03);
        setTimeout(function () { try { n.node.stop(); } catch (e) { } try { n.out.disconnect(); } catch (e) { } }, 180);
    } catch (e) { }
    if (!quiet) renderTone();
}
function toneFor(f, ms, opts) {
    toneStart(f, opts);
    var my = TN;
    return new Promise(function (res) { setTimeout(function () { if (TN === my) toneStop(); res(); }, ms); });
}

/* ═══ ГРАФИК ═════════════════════════════════════════════════════════════ */
var cv = $('tnCanvas'), plot = $('tnPlot'), g2d = cv.getContext('2d');
var W = 0, H = 0, DPR = 1, AXIS_H = 18;
var curveCache = null;   // {key, ys}
function xFrac(f) { return (Math.log(f) - Math.log(XMIN)) / (Math.log(XMAX) - Math.log(XMIN)); }
function fFromFrac(p) { return XMIN * Math.pow(XMAX / XMIN, p); }
function resize() {
    var r = plot.getBoundingClientRect();
    DPR = Math.min(2, window.devicePixelRatio || 1);
    W = Math.max(10, Math.round(r.width)); H = Math.max(10, Math.round(r.height));
    cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
    curveCache = null;
    renderAxis();
    drawAll();
}
function renderAxis() {
    var ax = $('tnAxis'), ticks = W < 420 ? [250, 1000, 4000, 16000] : W < 640 ? [250, 500, 1000, 2000, 4000, 8000, 16000] : [125, 250, 500, 1000, 2000, 4000, 8000, 16000];
    ax.textContent = '';
    ticks.forEach(function (f) {
        var s = document.createElement('span');
        s.style.left = (xFrac(f) * 100).toFixed(2) + '%';
        s.textContent = f >= 1000 ? (f / 1000) + t('k') : String(f);
        ax.appendChild(s);
    });
}
/* Кривая фильтра: +20…−50 дБ. Сверху видно подъём краёв (до +20 дБ), снизу —
   дно полосы ровной линией: рябь нулей Чебышёва ниже −50 дБ показывать
   незачем, обещание звучит как «не меньше 50 дБ по всей полосе». */
function yCurve(db) {
    var top = H * 0.1, bot = H - AXIS_H - 3;
    var c = Math.max(-DSP.DEPTH_DB, Math.min(20, db));
    return top + (20 - c) / (20 + DSP.DEPTH_DB) * (bot - top);
}
function ySpec(db) {    // спектры: −115…−25 дБ
    var top = H * 0.16, bot = H - AXIS_H - 2;
    var p = (db + 115) / 90;
    return bot - Math.min(1, Math.max(0, p)) * (bot - top);
}
function currentProfile() {
    if (S.src === 'music') { var tr = TRACKS[CUR]; return tr && tr.profile ? tr.profile : null; }
    if (S.src === 'tab') return null;
    return noiseProfile(S.src);
}
function filterCurve() {
    var d = G && G.design ? G.design : designFor(AC ? AC.sampleRate : 48000);
    var key = W + '|' + JSON.stringify(d.sos.length) + '|' + d.bands.map(function (b) { return b.fl.toFixed(1) + '-' + b.fh.toFixed(1); }).join(',') + '|' + (S.edge ? S.edgeDb : 0) + '|' + S.tilt;
    if (curveCache && curveCache.key === key) return curveCache;
    var n = Math.max(2, Math.round(W)), fr = new Array(n);
    for (var i = 0; i < n; i++) fr[i] = fFromFrac(i / (n - 1));
    var fs = AC ? AC.sampleRate : 48000;
    var r = DSP.sosResponse(d.sos, fr.map(function (f) { return Math.min(f, fs * 0.499); }), fs);
    curveCache = { key: key, db: r, fr: fr, design: d };
    return curveCache;
}
/* Оба спектра — мощность в полосе 1/12 октавы, как у анализатора звука:
   розовый шум на таком графике ровный. Живой и «в покое» считаются одинаково,
   иначе при нажатии «Слушать» картинка меняла наклон. */
function specFromProfile(p, n) {
    var out = new Float64Array(n), off = null;
    for (var i = 0; i < n; i++) {
        var f = fFromFrac(i / (n - 1)), lo = f * Math.pow(2, -1 / 24), hi = f * Math.pow(2, 1 / 24);
        var a = Math.max(1, Math.floor(lo / p.bin)), b = Math.min(p.psd.length - 1, Math.ceil(hi / p.bin)), s = 0, c = 0;
        for (var k = a; k <= b; k++) { s += p.psd[k]; c++; }
        out[i] = 10 * Math.log10(s + 1e-20);
    }
    /* Привязка уровня: средний 500 Гц–4 кГц кладём на −62 дБ шкалы. */
    var sum = 0, cnt = 0;
    for (i = 0; i < n; i++) { var ff = fFromFrac(i / (n - 1)); if (ff >= 500 && ff <= 4000) { sum += out[i]; cnt++; } }
    off = cnt ? -62 - sum / cnt : 0;
    for (i = 0; i < n; i++) out[i] += off;
    return out;
}
var fbufPre = null, fbufPost = null;
function specFromAnalyser(an, n, buf) {
    an.getFloatFrequencyData(buf);
    var out = new Float64Array(n), sr = an.context.sampleRate, bin = sr / an.fftSize;
    for (var i = 0; i < n; i++) {
        var f = fFromFrac(i / (n - 1)), lo = f * Math.pow(2, -1 / 24), hi = f * Math.pow(2, 1 / 24);
        var a = Math.max(1, Math.floor(lo / bin)), b = Math.min(buf.length - 1, Math.ceil(hi / bin)), s = 0, c = 0;
        for (var k = a; k <= b; k++) { s += Math.pow(10, buf[k] / 10); c++; }
        /* −16 дБ: розовый шум −20 дБFS ложится туда же, где спектр «в покое». */
        out[i] = 10 * Math.log10(s + 1e-20) - 16;
    }
    return out;
}
function pathArea(ys, n, color, fill) {
    g2d.beginPath();
    for (var i = 0; i < n; i++) { var x = i * W / (n - 1); if (i) g2d.lineTo(x, ys[i]); else g2d.moveTo(x, ys[i]); }
    if (fill) {
        g2d.lineTo(W, H - AXIS_H); g2d.lineTo(0, H - AXIS_H); g2d.closePath();
        g2d.fillStyle = fill; g2d.fill();
    } else { g2d.strokeStyle = color; g2d.stroke(); }
}
function drawAll(live) {
    if (!W || !H) return;
    g2d.setTransform(DPR, 0, 0, DPR, 0, 0);
    g2d.clearRect(0, 0, W, H);
    var n = Math.max(2, Math.round(W / 2)), i;
    /* сетка октав */
    g2d.strokeStyle = 'rgba(255,255,255,.05)'; g2d.lineWidth = 1;
    [125, 250, 500, 1000, 2000, 4000, 8000, 16000].forEach(function (f) {
        var x = Math.round(xFrac(f) * W) + 0.5; g2d.beginPath(); g2d.moveTo(x, 0); g2d.lineTo(x, H - AXIS_H); g2d.stroke();
    });
    var cc = filterCurve();
    /* спектры */
    var pre = null, post = null;
    if (live && G && PLAY.on) {
        if (!fbufPre || fbufPre.length !== G.anPre.frequencyBinCount) { fbufPre = new Float32Array(G.anPre.frequencyBinCount); fbufPost = new Float32Array(G.anPost.frequencyBinCount); }
        pre = specFromAnalyser(G.anPre, n, fbufPre);
        post = specFromAnalyser(G.anPost, n, fbufPost);
    } else {
        var p = currentProfile();
        if (p) {
            pre = specFromProfile(p, n);
            post = new Float64Array(n);
            for (i = 0; i < n; i++) {
                var ci = Math.min(cc.db.length - 1, Math.round(i * (cc.db.length - 1) / (n - 1)));
                post[i] = pre[i] + cc.db[ci] + (G ? 20 * Math.log10(Math.max(1e-6, G.makeup.gain.value)) : 0);
            }
        }
    }
    if (pre) {
        var yp = new Float64Array(n), yo = new Float64Array(n);
        for (i = 0; i < n; i++) { yp[i] = ySpec(pre[i]); yo[i] = ySpec(post[i]); }
        g2d.lineWidth = 1;
        pathArea(yp, n, null, 'rgba(200,210,230,.12)');
        g2d.lineWidth = 1; pathArea(yp, n, 'rgba(200,210,230,.45)');
        var gr = g2d.createLinearGradient(0, 0, 0, H);
        gr.addColorStop(0, 'rgba(122,167,255,.55)'); gr.addColorStop(1, 'rgba(122,167,255,.04)');
        pathArea(yo, n, null, gr);
        g2d.lineWidth = 1.6; pathArea(yo, n, '#7aa7ff');
    }
    /* кривая фильтра */
    var m = cc.db.length, ys = new Float64Array(m);
    for (i = 0; i < m; i++) ys[i] = yCurve(cc.db[i]);
    g2d.lineWidth = 2; g2d.setLineDash([]);
    g2d.beginPath();
    for (i = 0; i < m; i++) { var xx = i * W / (m - 1); if (i) g2d.lineTo(xx, ys[i]); else g2d.moveTo(xx, ys[i]); }
    g2d.strokeStyle = '#fbbf24'; g2d.stroke();
    placeBands(cc.design);
}
function placeBands(d) {
    var b1 = $('tnBand'), b2 = $('tnBand2');
    [b1, b2].forEach(function (el, i) {
        var b = d.bands[i];
        if (!b) { el.hidden = true; return; }
        el.hidden = false;
        var l = xFrac(b.fl) * 100, r = xFrac(b.fh) * 100;
        el.style.left = l.toFixed(3) + '%'; el.style.width = Math.max(0.3, r - l).toFixed(3) + '%';
    });
    placeHandle($('tnHandle'), $('tnKnob'), S.f);
    var h2 = $('tnHandle2');
    if (S.two && S.f2 > 0 && isPro()) { h2.hidden = false; placeHandle(h2, $('tnKnob2'), S.f2); } else h2.hidden = true;
}
function placeHandle(h, knob, f) {
    var p = xFrac(f);
    h.style.left = (p * 100).toFixed(3) + '%';
    h.setAttribute('aria-valuenow', String(Math.round(f)));
    h.setAttribute('aria-valuetext', hz(f) + ' ' + t('hz'));
    knob.textContent = hz(f);
    /* Подпись не уходит за край графика. */
    var kw = knob.offsetWidth || 50, x = p * W, shift = 0;
    if (x - kw / 2 < 4) shift = 4 - (x - kw / 2);
    else if (x + kw / 2 > W - 4) shift = (W - 4) - (x + kw / 2);
    knob.style.transform = shift ? 'translateX(' + shift.toFixed(1) + 'px)' : '';
}

var rafOn = false, lastDraw = 0;
function loop() {
    if (rafOn) return;
    rafOn = true;
    (function frame(ts) {
        if (!PLAY.on || document.hidden) { rafOn = false; drawAll(false); return; }
        if (ts - lastDraw > 33) { lastDraw = ts; drawAll(true); }
        requestAnimationFrame(frame);
    })(0);
}

/* ── ручка: перетаскивание и клавиатура ─────────────────────────────────── */
var drag = null;
function fAtClient(x) {
    var r = plot.getBoundingClientRect();
    return clampF(fFromFrac(Math.min(1, Math.max(0, (x - r.left) / r.width))));
}
plot.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 || e.target.closest('.tn-empty')) return;
    var two = !$('tnHandle2').hidden;
    var which = 1;
    if (two) {
        var f = fAtClient(e.clientX);
        which = Math.abs(Math.log(f / S.f2)) < Math.abs(Math.log(f / S.f)) ? 2 : 1;
    }
    drag = { id: e.pointerId, which: which };
    try { plot.setPointerCapture(e.pointerId); } catch (x) { }
    moveTo(fAtClient(e.clientX), which);
    (which === 2 ? $('tnHandle2') : $('tnHandle')).focus({ preventScroll: true });
    e.preventDefault();
});
plot.addEventListener('pointermove', function (e) { if (drag && e.pointerId === drag.id) moveTo(fAtClient(e.clientX), drag.which); });
function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var w = drag.which; drag = null;
    feat('drag_notch', { f: w === 2 ? S.f2 : S.f });
    afterFreqChange(true);
}
plot.addEventListener('pointerup', endDrag);
plot.addEventListener('pointercancel', endDrag);
function moveTo(f, which) {
    f = Math.round(f);
    if (which === 2) S.f2 = f; else { S.f = f; S.matched = true; }
    if (TN) toneSet(which === 2 ? S.f2 : S.f);
    afterFreqChange(false);
}
function keyStep(e, which) {
    var f = which === 2 ? S.f2 : S.f, k = e.key, oct = 0;
    if (k === 'ArrowLeft' || k === 'ArrowDown') oct = e.shiftKey ? -1 / 6 : -1 / 48;
    else if (k === 'ArrowRight' || k === 'ArrowUp') oct = e.shiftKey ? 1 / 6 : 1 / 48;
    else if (k === 'PageDown') oct = -0.5;
    else if (k === 'PageUp') oct = 0.5;
    else if (k === 'Home') { moveTo(FMIN, which); e.preventDefault(); afterFreqChange(true); return; }
    else if (k === 'End') { moveTo(FMAX, which); e.preventDefault(); afterFreqChange(true); return; }
    else return;
    e.preventDefault();
    moveTo(clampF(f * Math.pow(2, oct)), which);
    afterFreqChange(true);
}
$('tnHandle').addEventListener('keydown', function (e) { keyStep(e, 1); });
$('tnHandle2').addEventListener('keydown', function (e) { keyStep(e, 2); });

var saveT = 0;
function afterFreqChange(commit) {
    $('tnFreq').value = hz(S.f);
    if (G) scheduleDesign(); else drawAll();
    renderMeta();
    if (commit) {
        clearTimeout(saveT);
        saveT = setTimeout(saveProfile, 250);
        if (PLAY.on) mediaSession(true);
        renderDlWhat();
    }
}

/* ── поле частоты ────────────────────────────────────────────────────────── */
function parseFreq(str) {
    var s = String(str || '').toLowerCase()
        .replace(/[\u0660-\u0669]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
        .replace(/[\u06f0-\u06f9]/g, function (d) { return String(d.charCodeAt(0) - 0x06f0); })
        .replace(/[\s\u00a0\u202f\u066c]/g, '').replace(/[,\u066b]/, '.');
    var mul = /(k|к|кгц|khz|кhz)/.test(s) ? 1000 : 1;
    var v = parseFloat(s.replace(/[^\d.]/g, ''));
    if (!isFinite(v) || v <= 0) return NaN;
    v *= mul;
    if (mul === 1 && v < 30) v *= 1000;   // «6.5» почти всегда значит килогерцы
    return v;
}
function commitFreqInput() {
    var el = $('tnFreq'), v = parseFreq(el.value);
    if (!isFinite(v)) { el.value = hz(S.f); toast(t('err_freq'), 'warning'); return; }
    var c = clampF(v);
    if (c !== v) toast(t('freq_clamped', { min: hz(FMIN), max: hz(FMAX) }), 'info');
    S.f = Math.round(c); S.matched = true;
    feat('freq_typed', { f: S.f });
    afterFreqChange(true);
    renderEmpty();
}
$('tnFreq').addEventListener('change', commitFreqInput);
$('tnFreq').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commitFreqInput(); $('tnFreq').blur(); } });
$('tnFreq').addEventListener('focus', function () { try { this.select(); } catch (e) { } });
Array.prototype.forEach.call(document.querySelectorAll('[data-nudge]'), function (b) {
    b.addEventListener('click', function () {
        moveTo(clampF(S.f * Math.pow(2, (+b.getAttribute('data-nudge')) / 24)), 1);
        afterFreqChange(true);
    });
});

/* ═══ ОТРИСОВКА СОСТОЯНИЯ ═══════════════════════════════════════════════ */
function fmtOct(w) { return w === 0.5 ? '½' : w === 1.5 ? '1½' : NF1.format(w); }
function renderMeta() {
    var d = G && G.design ? G.design : designFor(AC ? AC.sampleRate : 48000);
    var b = d.bands[0], W0 = widthOct();
    var txt = t('band_txt', { w: fmtOct(W0), lo: hz(b.fl), hi: hz(b.fh), db: DSP.DEPTH_DB });
    if (d.bands[1]) txt += ' · ' + t('band2_txt', { f: hz(d.bands[1].f0) });
    $('tnBandTxt').innerHTML = txt;
    updateGrade();
    renderNote();
    renderSums();
    renderMini();
}
function renderNote() {
    var n = $('tnNote'), f = S.f, kind = 'ok', msg;
    if (!S.matched) { kind = 'warn'; msg = t('note_unmatched', { f: hz(f) }); }
    else if (f < 1000) { kind = 'warn'; msg = t('note_low'); }
    else if (f <= 8000) msg = t('note_studied');
    else if (f <= 12000) { kind = 'warn'; msg = t('note_high'); }
    else { kind = 'warn'; msg = t('note_vhigh'); }
    n.textContent = msg; n.setAttribute('data-kind', kind);
}
function gradeFor(profile) {
    if (!profile) return null;
    var d = G && G.design ? G.design : designFor(profile.fs);
    var b = d.bands[0];
    var tilt = S.tilt ? DSP.tiltSections(profile.fs) : null;
    return DSP.suitability(profile, b.fl, b.fh, tilt);
}
function updateGrade() {
    var el = $('tnGrade'), g = gradeFor(currentProfile());
    if (!g) { el.hidden = true; }
    else {
        el.hidden = false;
        el.setAttribute('data-grade', g.grade);
        el.textContent = t('grade_' + g.grade);
        el.title = t('grade_title', { db: NF1.format(g.score) });
    }
    TRACKS.forEach(function (tr) { if (tr.profile) tr.grade = gradeFor(tr.profile); });
    renderList();
    var hint = $('tnSrcHint');
    if (S.src === 'music' && g && g.grade !== 'good' && !S.tilt) hint.textContent = t('hint_tilt');
    else hint.textContent = S.src === 'music' ? t('src_hint_music') : S.src === 'tab' ? t('src_hint_tab') : t('src_hint_noise');
}
function renderSums() {
    var s = summary();
    DKsum('tnSumPitch', S.matched ? hz(S.f) + ' ' + t('hz') + (s ? ' · ' + t('sum_matches', { n: s.n }) : '') : t('sum_not_matched'));
    var parts = [S.w === 'auto' ? t('w_auto_is', { w: fmtOct(widthOct()) }) : t('w_is', { w: fmtOct(widthOct()) })];
    if (S.tilt) parts.push(t('sum_tilt'));
    if (S.edge) parts.push(t('sum_edge', { db: S.edgeDb }));
    if (S.two && isPro()) parts.push(t('sum_two'));
    DKsum('tnSumNotch', parts.join(' · '));
    DKsum('tnSumSound', S.src === 'music' ? t('sum_music', { n: TRACKS.length }) : t('src_' + S.src));
    var today = Math.round(dayRec().m || 0);
    DKsum('tnSumProg', t('sum_prog', { m: today, g: S.goal }));
    renderHist();
}
function DKsum(id, text) { if (DK) DK.summary(id, text); else { var el = $(id); if (el) el.textContent = text; } }
function renderHist() {
    var el = $('tnHist'), s = summary(), rm = recentMatches();
    if (!s) { el.textContent = t('hist_none'); $('tnMatchLbl').textContent = t('match_start'); return; }
    var list = rm.filter(function (m) { return !m.practice; }).map(function (m) { return hz(m.f); }).join(' · ');
    el.innerHTML = t('hist_line', {
        list: '<b>' + list + '</b>',
        f: '<b>' + hz(s.f) + '</b>',
        spread: s.spread == null ? '—' : NF1.format(s.spread),
        state: '<span class="tn-state" data-s="' + s.state + '">' + t('state_' + s.state) + '</span>'
    }) + ' <button type="button" class="tn-linkbtn" id="tnHistReset">' + t('hist_reset') + '</button>';
    $('tnMatchLbl').textContent = s.n >= 3 && s.state === 'stable' ? t('match_again') : t('match_more');
    var rb = $('tnHistReset');
    if (rb) rb.addEventListener('click', function () {
        if (!window.confirm(t('hist_reset_q'))) return;
        MATCHES = []; saveMatches(); afterFreqChange(true); renderSums();
    });
}
function renderPlay() {
    var b = $('tnPlay'), on = PLAY.on;
    b.classList.toggle('dk-go', !on); b.classList.toggle('dk-stop', on);
    $('tnPlayIco').innerHTML = icon(on ? 'pause' : 'play');
    $('tnPlayLbl').textContent = on ? t('pause') : t('play');
    var pill = $('tnPill');
    if (on && PLAY.sys) { pill.setAttribute('data-state', 'wait'); pill.textContent = t('pill_interrupted'); }
    else if (on) { pill.setAttribute('data-state', 'run'); pill.textContent = t('pill_run'); }
    else if (TN) { pill.setAttribute('data-state', 'wait'); pill.textContent = t('pill_tone'); }
    else { pill.setAttribute('data-state', 'ready'); pill.textContent = t('pill_ready'); }
    var isTrack = S.src === 'music' && !!TRACKS[CUR];
    $('tnSrcLbl').textContent = isTrack ? TRACKS[CUR].name : t('src_' + S.src);
    $('tnSrcLbl').classList.toggle('is-track', isTrack);
    renderClock();
    renderMini();
    renderEmpty();
}
function renderTone() {
    var on = !!TN;
    $('tnTone').setAttribute('aria-pressed', on ? 'true' : 'false');
    $('tnTone').classList.toggle('is-on', on);
    $('tnToneLbl').textContent = on ? t('tone_stop') : t('tone_play');
    renderPlay();
}
function renderClock() {
    var el = $('tnClock');
    if (!PLAY.on) { el.textContent = ''; return; }
    var sec = Math.max(0, Math.round((nowMs() - PLAY.started) / 1000));
    if (PLAY.endAt) sec = Math.max(0, Math.round((PLAY.endAt - Date.now()) / 1000));
    var m = Math.floor(sec / 60), s = sec % 60, h = Math.floor(m / 60);
    el.textContent = (PLAY.endAt ? '−' : '') + (h ? h + ':' + String(m % 60).padStart(2, '0') : m) + ':' + String(s).padStart(2, '0');
}
function renderProgress() {
    var rec = dayRec(), today = Math.round(rec.m || 0), goal = S.goal;
    $('tnTodayV').textContent = t('today_v', { m: today, g: goal });
    $('tnTodayBar').style.width = Math.min(100, today / goal * 100).toFixed(1) + '%';
    $('tnTodayTop').textContent = t('today_short', { m: today });
    var wk = $('tnWeek'), days = [], max = goal;
    wk.textContent = '';
    for (var i = 6; i >= 0; i--) {
        var d = new Date(); d.setDate(d.getDate() - i);
        var k = dayKey(d), m = LOG.days[k] ? Math.round(LOG.days[k].m || 0) : 0;
        days.push({ d: d, m: m, today: i === 0 });
        max = Math.max(max, m);
    }
    var fmtD;
    try { fmtD = new Intl.DateTimeFormat(LOCALE, { weekday: 'narrow' }); } catch (e) { fmtD = { format: function (d) { return d.getDate(); } }; }
    var labels = [];
    days.forEach(function (x) {
        var c = document.createElement('div');
        c.className = 'tn-day' + (x.m >= goal ? ' is-goal' : x.m > 0 ? ' is-some' : '') + (x.today ? ' is-today' : '');
        var bar = document.createElement('i'); bar.style.height = Math.max(3, x.m / max * 56).toFixed(0) + 'px';
        var lb = document.createElement('span'); lb.textContent = fmtD.format(x.d);
        c.appendChild(bar); c.appendChild(lb); wk.appendChild(c);
        labels.push(fmtD.format(x.d) + ' ' + x.m);
    });
    wk.setAttribute('aria-label', t('week_aria') + ': ' + labels.join(', '));
    renderTrend();
    renderSums();
}
function renderTrend() {
    var keys = Object.keys(LOG.days).filter(function (k) { return LOG.days[k].l != null; }).sort();
    var el = $('tnTrend');
    if (!keys.length) { el.textContent = t('trend_none'); return; }
    var a = LOG.days[keys[0]], b = LOG.days[keys[keys.length - 1]];
    if (keys.length === 1) { el.innerHTML = t('trend_one', { l: '<b>' + a.l + '</b>', a: '<b>' + a.a + '</b>' }); return; }
    var weeks = Math.max(0, Math.round((new Date(keys[keys.length - 1]) - new Date(keys[0])) / (7 * 86400000)));
    el.innerHTML = t('trend_line', { l0: '<b>' + a.l + '</b>', l1: '<b>' + b.l + '</b>', a0: '<b>' + a.a + '</b>', a1: '<b>' + b.a + '</b>', w: weeks });
    var today = LOG.days[dayKey()];
    if (today && today.l != null) { $('tnLoud').value = today.l; $('tnAnnoy').value = today.a; $('tnLoudV').textContent = today.l; $('tnAnnoyV').textContent = today.a; }
}
function renderEmpty() { $('tnEmpty').hidden = !!S.matched || PLAY.on; }

/* ── мини-окно ───────────────────────────────────────────────────────────── */
var PIP = null;
/* Узлы мини-окна — ссылками: DeviceKit.openPip переносит #tnMini ТЕМ ЖЕ узлом
   в документ окна PiP, и $() (document.getElementById) их там не находит —
   renderMini падал ровно тогда, когда окно открыто (окно пустое, а падение
   посреди смены «играет/пауза» обрывало и её). */
var MINI = { f: $('tnMiniF'), src: $('tnMiniSrc'), t: $('tnMiniT'), play: $('tnMiniPlay') };
function renderMini() {
    if (!PIP) return;
    MINI.f.textContent = hz(S.f) + ' ' + t('hz');
    MINI.src.textContent = S.src === 'music' && TRACKS[CUR] ? TRACKS[CUR].name : t('src_' + S.src);
    MINI.t.textContent = t('today_short', { m: Math.round(dayRec().m || 0) }) + (PLAY.on ? ' · ' + $('tnClock').textContent : '');
    MINI.play.innerHTML = icon(PLAY.on ? 'pause' : 'play') + '<span>' + (PLAY.on ? t('pause') : t('play')) + '</span>';
    MINI.play.classList.toggle('dk-go', !PLAY.on); MINI.play.classList.toggle('dk-stop', PLAY.on);
}
if (DK && DK.pipSupported()) {
    $('tnPip').hidden = false;
    $('tnPip').addEventListener('click', function () {
        if (PIP) { try { PIP.close(); } catch (e) { } return; }
        DK.openPip($('tnMini'), { width: 300, height: 190, onOpen: function (w) { PIP = w; renderMini(); }, onClose: function () { PIP = null; } }).then(function (w) {
            if (w) feat('pip_open', {});
        });
    });
    MINI.play.addEventListener('click', togglePlay);
}

/* ═══ РАЗДЕЛЫ ИНСПЕКТОРА ═════════════════════════════════════════════════ */
function openSection(name) {
    var sec = document.querySelector('.dk-sec[data-sec="' + name + '"]');
    if (sec && DK) DK.openSection(sec);
}
function segBind(id, key, onChange) {
    var box = $(id);
    function mark() { Array.prototype.forEach.call(box.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === S[key] ? 'true' : 'false'); }); }
    box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-v]'); if (!b) return;
        S[key] = b.getAttribute('data-v'); mark(); saveProfile(); if (onChange) onChange();
    });
    mark();
    return mark;
}

$('tnTone').addEventListener('click', function () {
    if (TN) { toneStop(); return; }
    toneStart(S.f); feat('tone_listen', { f: S.f, stim: S.stim });
});

$('tnOctBtn').addEventListener('click', function () { openMatch('oct-only'); });

/* ширина */
function markWidth() {
    Array.prototype.forEach.call($('tnWidth').querySelectorAll('[data-w]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-w') === S.w ? 'true' : 'false'); });
}
$('tnWidth').addEventListener('click', function (e) {
    var b = e.target.closest('[data-w]'); if (!b) return;
    S.w = b.getAttribute('data-w'); markWidth(); saveProfile();
    if (G) applyDesign(); else drawAll();
    renderMeta(); feat('width_' + S.w, {});
});
markWidth();

$('tnTilt').checked = !!S.tilt;
$('tnTilt').addEventListener('change', function () { S.tilt = this.checked; saveProfile(); if (G) applyDesign(); else drawAll(); renderMeta(); feat('tilt', { on: S.tilt ? 1 : 0 }); });
$('tnEdge').checked = !!S.edge;
$('tnEdgeBox').hidden = !S.edge;
$('tnEdgeDb').value = S.edgeDb; $('tnEdgeV').textContent = '+' + S.edgeDb + ' dB';
$('tnEdge').addEventListener('change', function () {
    S.edge = this.checked; $('tnEdgeBox').hidden = !S.edge; saveProfile();
    if (G) applyDesign(); else drawAll(); renderMeta(); feat('edge', { on: S.edge ? 1 : 0 });
});
$('tnEdgeDb').addEventListener('input', function () {
    S.edgeDb = +this.value; $('tnEdgeV').textContent = '+' + S.edgeDb + ' dB';
    if (G) scheduleDesign(); else drawAll();
});
$('tnEdgeDb').addEventListener('change', function () { saveProfile(); renderMeta(); });

/* второй нотч (Премиум) */
function renderTwo() {
    var pro = isPro();
    $('tnTwo').checked = !!(S.two && pro);
    $('tnF2Box').hidden = !(S.two && pro);
    if (S.two && pro && !(S.f2 > 0)) S.f2 = clampF(Math.round(S.f / 2));
    $('tnF2').value = S.f2 > 0 ? hz(S.f2) : '';
}
$('tnTwo').addEventListener('change', function () {
    if (this.checked && !isPro()) { this.checked = false; upsell('two'); return; }
    S.two = this.checked; renderTwo(); saveProfile();
    if (G) applyDesign(); else drawAll(); renderMeta(); feat('two_notch', { on: S.two ? 1 : 0 });
});
function commitF2() {
    var v = parseFreq($('tnF2').value);
    if (!isFinite(v)) { $('tnF2').value = S.f2 ? hz(S.f2) : ''; return; }
    S.f2 = Math.round(clampF(v)); $('tnF2').value = hz(S.f2); saveProfile();
    if (G) applyDesign(); else drawAll(); renderMeta();
}
$('tnF2').addEventListener('change', commitF2);
$('tnF2').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commitF2(); } });
Array.prototype.forEach.call(document.querySelectorAll('[data-f2step]'), function (b) {
    b.addEventListener('click', function () {
        S.f2 = Math.round(clampF((S.f2 || S.f / 2) * Math.pow(2, (+b.getAttribute('data-f2step')) / 24)));
        $('tnF2').value = hz(S.f2); saveProfile(); if (G) scheduleDesign(); else drawAll(); renderMeta();
    });
});

/* ── Премиум: предложение там, где человек упёрся ───────────────────────── */
function upsell(what) {
    var box = document.querySelector('.tn-offer[data-offer="' + what + '"]');
    if (box) {
        box.hidden = false;
        box.innerHTML = '<div class="dk-offer-t">' + icon('star') + '<span>' + t('pro_title', { plan: CFG.planName || 'Pro' }) + '</span></div>' +
            '<ul><li>' + t('pro_two') + '</li><li>' + t('pro_tab') + '</li><li>' + t('pro_batch') + '</li><li>' + t('pro_pdf') + '</li></ul>' +
            '<div class="dk-row"><a class="dk-btn dk-primary dk-sm" href="' + (CFG.proUrl || '#') + '">' + t('pro_cta', { plan: CFG.planName || 'Pro' }) + '</a></div>';
        var a = box.querySelector('a');
        if (a) a.addEventListener('click', function () { funnel('perk_click', { what: what }); });
    }
    toast(t('pro_locked', { plan: CFG.planName || 'Pro' }), 'info');
    funnel('perk_upsell', { what: what });
}
function renderPro() {
    var pro = isPro();
    Array.prototype.forEach.call(document.querySelectorAll('[data-pro-tag]'), function (el) { el.hidden = pro; });
    if (pro) Array.prototype.forEach.call(document.querySelectorAll('.tn-offer'), function (el) { el.hidden = true; });
    renderTwo();
    renderDlWhat();
}

/* ── источник ────────────────────────────────────────────────────────────── */
function setSource(src) {
    if (src === 'tab' && !isPro()) { upsell('tab'); return; }
    var live = PLAY.on && PLAY.kind !== src;
    S.src = src; saveProfile();
    renderSound();
    if (G) setMakeup();
    drawAll(); renderMeta(); renderPlay(); renderDlWhat();
    if (live) {
        if (src === 'tab' && !TAB) { stopPlay('switch'); return; }
        if (src === 'music' && !TRACKS.length) { stopPlay('switch'); return; }
        swapSource(src);
    }
}
function renderSound() {
    Array.prototype.forEach.call($('tnSource').querySelectorAll('[data-src]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-src') === S.src ? 'true' : 'false');
    });
    var tabChip = $('tnSource').querySelector('[data-src="tab"]');
    tabChip.hidden = !tabSupported();
    $('tnUplBox').hidden = S.src !== 'music';
    $('tnUplBox').classList.toggle('has-tracks', TRACKS.length > 0);
    $('tnList').hidden = S.src !== 'music' || !TRACKS.length;
    $('tnTabBox').hidden = S.src !== 'tab';
    updateGrade();
    renderSums();
}
$('tnSource').addEventListener('click', function (e) {
    var b = e.target.closest('[data-src]'); if (!b) return;
    var src = b.getAttribute('data-src');
    feat('source_' + src, {});
    setSource(src);
});
$('tnTabPick').addEventListener('click', pickTab);

/* ── треки ───────────────────────────────────────────────────────────────── */
var TID = 0;
function addFiles(files) {
    var list = Array.prototype.slice.call(files || []).filter(function (f) { return f && f.size > 0; });
    if (!list.length) return;
    list.forEach(function (f) {
        var tr = { id: ++TID, file: f, name: (f.name || 'track').replace(/\.[^.]+$/, ''), url: URL.createObjectURL(f), profile: null, grade: null };
        TRACKS.push(tr);
        analyseTrack(tr);
    });
    if (S.src !== 'music') setSource('music'); else { renderSound(); renderDlWhat(); }
    renderList(); renderSound(); renderPlay();
    feat('tracks_added', { n: list.length, total: TRACKS.length });
    stage('tracks');
}
/* Спектр трека: декод до 40 МБ целиком (равномерная выборка кадров), иначе —
   живой анализатор, пока трек играет. */
var decodeQ = Promise.resolve();
function analyseTrack(tr) {
    if (tr.file.size > 40 * 1024 * 1024) { tr.live = true; renderList(); return; }
    decodeQ = decodeQ.then(function () {
        return tr.file.arrayBuffer().then(function (ab) {
            var C = window.OfflineAudioContext || window.webkitOfflineAudioContext;
            var oc = new C(1, 1, 48000);
            return new Promise(function (res, rej) {
                var p = oc.decodeAudioData(ab, res, rej);
                if (p && p.then) p.then(res, rej);
            });
        }).then(function (buf) {
            var ch = [];
            for (var i = 0; i < Math.min(2, buf.numberOfChannels); i++) ch.push(buf.getChannelData(i));
            tr.profile = DSP.spectrumProfile(ch, buf.sampleRate, 600);
            tr.dur = buf.duration;
            tr.grade = gradeFor(tr.profile);
            if (TRACKS[CUR] === tr) { if (G) setMakeup(); drawAll(); updateGrade(); }
            renderList();
        }).catch(function () {
            tr.live = true; renderList();
            feat('track_decode_fail', { ext: (tr.file.name.split('.').pop() || '').slice(0, 5) });
        });
    });
}
var liveT = 0;
function liveAnalyse(tr) {
    clearTimeout(liveT);
    if (!tr || tr.profile || !tr.live) return;
    /* 20 секунд сглаженного анализатора — достаточно, чтобы оценка перестала
       прыгать; дальше спектр трека считается известным. */
    liveT = setTimeout(function () {
        if (!G || !PLAY.on || TRACKS[CUR] !== tr) return;
        var buf = new Float32Array(G.anPre.frequencyBinCount);
        G.anPre.getFloatFrequencyData(buf);
        tr.profile = DSP.profileFromAnalyser(buf, G.ctx.sampleRate, G.anPre.fftSize);
        tr.grade = gradeFor(tr.profile);
        setMakeup(); updateGrade(); renderList();
    }, 20000);
}
function renderList() {
    var ul = $('tnList');
    ul.textContent = '';
    ul.hidden = S.src !== 'music' || !TRACKS.length;
    TRACKS.forEach(function (tr, i) {
        var li = document.createElement('li');
        li.className = 'tn-trk' + (i === CUR ? ' is-cur' : '');
        var n = document.createElement('button'); n.type = 'button'; n.className = 'tn-trk-n'; n.textContent = String(i + 1);
        n.title = t('trk_play'); n.setAttribute('aria-label', t('trk_play') + ': ' + tr.name);
        n.addEventListener('click', function () { CUR = i; renderList(); updateGrade(); if (PLAY.on) nextTrack(0); else startPlay(); });
        var nm = document.createElement('span'); nm.className = 'tn-trk-t'; nm.textContent = tr.name; nm.title = tr.name;
        var g = document.createElement('span'); g.className = 'tn-trk-g';
        if (tr.grade) { g.setAttribute('data-grade', tr.grade.grade); g.textContent = t('g_' + tr.grade.grade); g.title = t('grade_title', { db: NF1.format(tr.grade.score) }); }
        else g.textContent = tr.live ? t('g_live') : t('g_wait');
        var x = document.createElement('button'); x.type = 'button'; x.className = 'tn-trk-x'; x.innerHTML = icon('x');
        x.setAttribute('aria-label', t('trk_remove') + ': ' + tr.name); x.title = t('trk_remove');
        x.addEventListener('click', function () { removeTrack(i); });
        li.appendChild(n); li.appendChild(nm); li.appendChild(g); li.appendChild(x);
        ul.appendChild(li);
    });
}
function removeTrack(i) {
    var tr = TRACKS[i]; if (!tr) return;
    var playingThis = PLAY.on && PLAY.kind === 'music' && i === CUR;
    TRACKS.splice(i, 1);
    try { URL.revokeObjectURL(tr.url); } catch (e) { }
    if (CUR >= TRACKS.length) CUR = 0;
    if (!TRACKS.length) { if (PLAY.on && PLAY.kind === 'music') stopPlay('empty'); }
    else if (playingThis) nextTrack(0, true);
    renderList(); renderSound(); renderDlWhat();
}
(function bindUploader() {
    var z = $('tnDrop'); if (!z) return;
    var onPick = function (f, d) {
        var files = (d && d.files && d.files.length) ? d.files : (f ? [f] : []);
        addFiles(files);
    };
    if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(z, onPick);
    else z.addEventListener('tool-uploader:file', function (e) { onPick(e.detail && e.detail.file, e.detail); });
})();

/* ── прогресс ────────────────────────────────────────────────────────────── */
$('tnGoal').value = String(S.goal);
$('tnGoal').addEventListener('change', function () { S.goal = +this.value; saveProfile(); renderProgress(); });
['tnLoud', 'tnAnnoy'].forEach(function (id) {
    $(id).addEventListener('input', function () { $(id + 'V').textContent = this.value; });
});
$('tnRateSave').addEventListener('click', function () {
    var rec = dayRec();
    rec.l = +$('tnLoud').value; rec.a = +$('tnAnnoy').value;
    if (!LOG.first) LOG.first = dayKey();
    saveLog(); renderTrend();
    toast(t('rate_saved'), 'success');
    feat('diary_rate', { l: rec.l, a: rec.a, days: Object.keys(LOG.days).length });
});
$('tnReset').addEventListener('click', function () {
    if (!window.confirm(t('reset_q'))) return;
    LOG = { days: {}, first: null }; saveLog(); renderProgress();
    feat('diary_reset', {});
});

/* Напоминание: файл календаря с ежедневным повтором на 90 дней — у веба нет
   надёжных локальных уведомлений по расписанию, а календарь есть у всех. */
$('tnIcs').addEventListener('click', function () {
    var d = new Date(); d.setDate(d.getDate() + 1); d.setHours(20, 0, 0, 0);
    function stamp(x) {
        return x.getFullYear() + String(x.getMonth() + 1).padStart(2, '0') + String(x.getDate()).padStart(2, '0') + 'T' +
            String(x.getHours()).padStart(2, '0') + String(x.getMinutes()).padStart(2, '0') + '00';
    }
    var end = new Date(d.getTime() + Math.min(120, S.goal) * 60000);
    var url = location.origin + location.pathname;
    function esc(s) { return String(s).replace(/[\\,;]/g, function (c) { return '\\' + c; }).replace(/\n/g, '\\n'); }
    /* RFC 5545: строка не длиннее 75 октетов, продолжение — с пробела. */
    function fold(line) {
        var out = [], cur = '', bytes = 0, enc = new TextEncoder();
        Array.from(line).forEach(function (ch) {
            var n = enc.encode(ch).length;
            if (bytes + n > (out.length ? 74 : 75)) { out.push(cur); cur = ''; bytes = 0; }
            cur += ch; bytes += n;
        });
        out.push(cur);
        return out.join('\r\n ');
    }
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + (CFG.brand || 'Timbrica') + '//tinnitus-notch//EN', 'CALSCALE:GREGORIAN',
        'BEGIN:VEVENT', 'UID:tn-' + Date.now() + '@' + location.hostname, 'DTSTAMP:' + stamp(new Date()),
        'DTSTART:' + stamp(d), 'DTEND:' + stamp(end), 'RRULE:FREQ=DAILY;COUNT=90',
        'SUMMARY:' + esc(t('ics_title')), 'DESCRIPTION:' + esc(t('ics_desc', { f: hz(S.f) }) + '\n' + url), 'URL:' + url,
        'BEGIN:VALARM', 'TRIGGER:PT0M', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(t('ics_title')), 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'].map(fold).join('\r\n');
    var blob = new Blob([ics], { type: 'text/calendar' });
    if (window.__downloadFile) window.__downloadFile(blob, 'tinnitus-reminder.ics');
    feat('ics', {});
});

/* ── поделиться настройками ──────────────────────────────────────────────── */
$('tnShare').addEventListener('click', function () {
    var p = new URLSearchParams();
    p.set('f', String(S.f)); p.set('w', S.w);
    if (S.edge) p.set('e', String(S.edgeDb)); else p.set('e', '0');
    p.set('t', S.tilt ? '1' : '0');
    if (S.two && S.f2 > 0 && isPro()) p.set('f2', String(S.f2));
    var url = location.origin + location.pathname + '#' + p.toString();
    function done() { toast(t('share_copied'), 'success'); }
    if (navigator.share && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        navigator.share({ title: document.title, url: url }).catch(function () { });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt(t('share'), url); });
    } else window.prompt(t('share'), url);
    feat('share', {});
});

/* ═══ ПОДБОР ЧАСТОТЫ (диалог) ════════════════════════════════════════════ */
var dlg = $('tnMatch');
var MX = { step: 'prep', runs: 0, f: 4000, pick: 1, mode: 'full', stim: S.stim, ear: S.ear, vol: S.toneVol, octPlaying: false };
var SL_MIN = FMIN, SL_MAX = FMAX;
function sl2f(v) { return SL_MIN * Math.pow(SL_MAX / SL_MIN, v / 1000); }
function f2sl(f) { return Math.round(1000 * Math.log(f / SL_MIN) / Math.log(SL_MAX / SL_MIN)); }

function openMatch(mode) {
    MX.mode = mode || 'full';
    MX.runs = 0; MX.stim = S.stim; MX.ear = S.ear; MX.vol = S.toneVol;
    if (PLAY.on) stopPlay('match');
    $('tnMVol').value = MX.vol; $('tnMVolV').textContent = MX.vol + '%';
    markDlgSeg('tnMEar', MX.ear); markDlgOpt('tnMStim', MX.stim);
    try { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } catch (e) { dlg.setAttribute('open', ''); }
    if (MX.mode === 'oct-only') { MX.f = S.f; goStep('oct'); }
    else goStep('prep');
    stage('match_open', { mode: MX.mode });
    funnel('match_open', { mode: MX.mode, prev: MATCHES.length });
}
function closeMatch() {
    toneStop();
    try { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } catch (e) { dlg.removeAttribute('open'); }
}
dlg.addEventListener('close', function () { toneStop(); renderTone(); });
dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) { closeMatch(); return; }
    /* Щелчок по подложке закрывает — у <dialog> без closedby это делаем сами. */
    if (e.target === dlg) {
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeMatch();
    }
});
function markDlgSeg(id, v) { Array.prototype.forEach.call($(id).querySelectorAll('[data-v]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); }); }
function markDlgOpt(id, v) { markDlgSeg(id, v); }
$('tnMEar').addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; MX.ear = b.getAttribute('data-v'); markDlgSeg('tnMEar', MX.ear); });
$('tnMStim').addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (!b) return; MX.stim = b.getAttribute('data-v'); markDlgOpt('tnMStim', MX.stim); });
$('tnMVol').addEventListener('input', function () { MX.vol = +this.value; $('tnMVolV').textContent = MX.vol + '%'; });
Array.prototype.forEach.call(dlg.querySelectorAll('[data-lr]'), function (b) {
    b.addEventListener('click', function () { toneFor(1000, 900, { stim: 'tone', ear: b.getAttribute('data-lr'), vol: MX.vol }); });
});

function goStep(step) {
    MX.step = step;
    Array.prototype.forEach.call(dlg.querySelectorAll('.tn-step'), function (s) { s.hidden = s.getAttribute('data-step') !== step; });
    var next = $('tnMNext'), back = $('tnMBack'), more = $('tnMMore');
    back.hidden = true; more.hidden = true;
    var dots = $('tnDots').children;
    for (var i = 0; i < dots.length; i++) { dots[i].className = i < MX.runs ? 'done' : (i === MX.runs && step !== 'result' ? 'on' : ''); }
    $('tnDots').hidden = MX.mode === 'oct-only';
    if (step === 'prep') { next.textContent = t('m_begin'); toneStop(); }
    else if (step === 'run') {
        var first = !MATCHES.length && MX.runs === 0;
        $('tnRunT').textContent = t(first ? 'm_run_practice' : 'm_run', { n: MX.runs + 1 });
        /* Старт — случайная точка 1–8 кГц: с одного и того же старта люди
           «прилипают» к нему (Neff 2019: старт с 500 Гц тянул ответы вниз). */
        MX.f = Math.round(1000 * Math.pow(8, Math.random()));
        $('tnRunSlider').value = f2sl(MX.f);
        $('tnRVol').value = MX.vol; $('tnRVolV').textContent = MX.vol + '%';
        renderRunF();
        next.textContent = t('m_matches');
        toneStart(MX.f, { stim: MX.stim, ear: MX.ear, vol: MX.vol });
    } else if (step === 'oct') {
        toneStop();
        MX.pick = 1;
        var fs = [MX.f / 2, MX.f, MX.f * 2];
        ['tnOctA', 'tnOctB', 'tnOctC'].forEach(function (id, i) { $(id).textContent = hz(fs[i]); });
        Array.prototype.forEach.call($('tnOctOpts').querySelectorAll('[data-m]'), function (b) {
            var m = +b.getAttribute('data-m'), f = MX.f * m;
            b.disabled = f < FMIN * 0.99 || f > FMAX * 1.01;
            b.setAttribute('aria-pressed', m === 1 ? 'true' : 'false');
        });
        next.textContent = MX.mode === 'oct-only' ? t('apply') : t('next');
        playOctaves();
    } else if (step === 'result') {
        toneStop();
        var s = summary();
        $('tnResF').textContent = s ? hz(s.f) : hz(S.f);
        var html = '';
        if (s) {
            html += '<div>' + t('res_runs', { list: '<b>' + recentMatches().filter(function (m) { return !m.practice; }).map(function (m) { return hz(m.f); }).join(' · ') + '</b>' }) + '</div>';
            if (s.spread != null) html += '<div>' + t('res_spread', { s: '<b>' + NF1.format(s.spread) + '</b>' }) + '</div>';
            html += '<div>' + t('res_state_' + s.state, { w: '<b>' + fmtOct(s.autoW) + '</b>' }) + '</div>';
        } else html = '<div>' + t('res_practice') + '</div>';
        $('tnResTxt').innerHTML = html;
        next.textContent = t('apply');
        more.hidden = false;
    }
}
function renderRunF() { $('tnRunF').textContent = hz(MX.f); }
$('tnRunSlider').addEventListener('input', function () { MX.f = Math.round(sl2f(+this.value)); renderRunF(); if (TN) toneSet(MX.f); else toneStart(MX.f, { stim: MX.stim, ear: MX.ear, vol: MX.vol }); });
Array.prototype.forEach.call(dlg.querySelectorAll('[data-rstep]'), function (b) {
    b.addEventListener('click', function () {
        MX.f = Math.round(clampF(MX.f * Math.pow(2, (+b.getAttribute('data-rstep')) / 48)));
        $('tnRunSlider').value = f2sl(MX.f); renderRunF();
        if (TN) toneSet(MX.f); else toneStart(MX.f, { stim: MX.stim, ear: MX.ear, vol: MX.vol });
    });
});
$('tnRVol').addEventListener('input', function () { MX.vol = +this.value; $('tnRVolV').textContent = MX.vol + '%'; if (TN) toneSet(MX.f, MX.vol); });

var octSeq = 0;
function playOctaves() {
    var my = ++octSeq, fs = [MX.f / 2, MX.f, MX.f * 2], btns = $('tnOctOpts').querySelectorAll('[data-m]'), i = 0;
    (function nextOne() {
        if (my !== octSeq || MX.step !== 'oct' || !dlg.open) return;
        if (i >= 3) return;
        var f = fs[i], b = btns[i]; i++;
        if (b.disabled) { nextOne(); return; }
        b.classList.add('is-on');
        toneFor(f, 900, { stim: MX.stim, ear: MX.ear, vol: MX.vol }).then(function () { b.classList.remove('is-on'); setTimeout(nextOne, 250); });
    })();
}
$('tnOctOpts').addEventListener('click', function (e) {
    var b = e.target.closest('[data-m]'); if (!b || b.disabled) return;
    octSeq++;
    MX.pick = +b.getAttribute('data-m');
    Array.prototype.forEach.call($('tnOctOpts').querySelectorAll('[data-m]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); x.classList.remove('is-on'); });
    toneFor(MX.f * MX.pick, 900, { stim: MX.stim, ear: MX.ear, vol: MX.vol });
});

$('tnMNext').addEventListener('click', function () {
    if (MX.step === 'prep') {
        S.stim = MX.stim; S.ear = MX.ear; S.toneVol = MX.vol; saveProfile();
        syncPitchControls();
        goStep('run'); funnel('match_run', { n: MX.runs + 1 });
    } else if (MX.step === 'run') {
        goStep('oct');
    } else if (MX.step === 'oct') {
        var f = Math.round(clampF(MX.f * MX.pick));
        if (MX.mode === 'oct-only') {
            if (MX.pick !== 1) toast(t('oct_moved', { f: hz(f) }), 'info');
            S.f = f; S.matched = true; closeMatch(); afterFreqChange(true); renderEmpty();
            feat('octave_pick', { m: MX.pick });
            return;
        }
        var practice = !MATCHES.length && MX.runs === 0;
        MATCHES.push({ t: Date.now(), f: f, practice: practice, stim: MX.stim, ear: MX.ear, oct: MX.pick });
        saveMatches();
        MX.runs++;
        feat('match_run_done', { n: MX.runs, oct: MX.pick, practice: practice ? 1 : 0 });
        if (MX.runs < 3) goStep('run');
        else goStep('result');
    } else if (MX.step === 'result') {
        var s = summary();
        if (s) { S.f = s.f; S.matched = true; }
        saveProfile(); closeMatch(); afterFreqChange(true); renderEmpty(); renderSums();
        funnel('match_done', { n: s ? s.n : 0, state: s ? s.state : 'none', spread: s && s.spread != null ? Math.round(s.spread * 100) / 100 : null });
        stage('match_done');
        toast(t('match_applied', { f: hz(S.f) }), 'success');
    }
});
$('tnMMore').addEventListener('click', function () { goStep('run'); });
Array.prototype.forEach.call(document.querySelectorAll('[data-open-match]'), function (b) { b.addEventListener('click', function () { openMatch('full'); }); });
$('tnEmptyKnow').addEventListener('click', function () {
    S.matched = true; renderEmpty(); saveProfile();
    var el = $('tnFreq'); el.focus(); try { el.select(); } catch (e) { }
});
function syncPitchControls() { renderTone(); }

/* ═══ ВЫГРУЗКА ═══════════════════════════════════════════════════════════ */
var EXP = null;
function renderDlWhat() {
    var sel = $('tnDlWhat'), cur = sel.value, opts = [];
    if (S.src === 'music' && TRACKS.length) {
        opts.push(['track', t('dl_track')]);
        if (TRACKS.length > 1) opts.push(['all', t('dl_all', { n: TRACKS.length }) + (isPro() ? '' : ' ★')]);
    } else {
        var type = S.src === 'music' || S.src === 'tab' ? 'pink' : S.src;
        [10, 30, 60].forEach(function (m) { opts.push(['n' + m, t('dl_noise', { m: m, src: t('src_' + type) })]); });
        if (S.src === 'tab') opts.unshift(['_', t('dl_need_src')]);
    }
    sel.textContent = '';
    opts.forEach(function (o) { var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; sel.appendChild(op); });
    if (opts.some(function (o) { return o[0] === cur; })) sel.value = cur;
    else if (opts[0] && opts[0][0] === '_' && opts[1]) sel.value = opts[1][0];
    if (sel.options[0] && sel.options[0].value === '_') sel.options[0].disabled = true;
    var o = sel.options[sel.selectedIndex];
    DKsum('tnSumDl', (o ? o.textContent : '') + ' · ' + (FMT === 'wav' ? 'WAV' : FMT === 'mp3-320' ? 'MP3 320' : 'MP3 128'));
}
/* Формат: MP3 128 · MP3 320 · WAV. Потолок битрейта держит общий гейт качества
   (quality-tier.js): у бесплатного тарифа 320 закрыт пометкой. Замер 29.09.2026:
   MP3 и на 128, и на 320 кбит/с сохраняет вырезанную полосу глубже 40 дБ (шум
   2–14 кГц, музыка 1–8 кГц), а AAC 128 и Opus 128 заливали её на 8–16 дБ —
   поэтому их в списке нет. */
var FMTS = ['mp3-128', 'mp3-320', 'wav'];
var FMT = TS.load(SLUG, 'fmt', '');
if (FMTS.indexOf(FMT) < 0) FMT = isPro() ? 'mp3-320' : 'mp3-128';
function markFmt() { Array.prototype.forEach.call($('tnDlFmt').querySelectorAll('[data-v]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === FMT ? 'true' : 'false'); }); }
$('tnDlFmt').addEventListener('click', function (e) {
    var b = e.target.closest('[data-v]'); if (!b || b.disabled) return;
    FMT = b.getAttribute('data-v'); TS.save(SLUG, 'fmt', FMT); markFmt(); renderDlWhat();
});
markFmt();

function lazyScripts() {
    var L = CFG.lazy || {}, need = [];
    if (!window.MP3Encoder) need.push(L.mp3);
    if (!window.OutputSink) need.push(L.sink);
    if (!window.MasteringLimiter) need.push(L.limiter);
    need = need.filter(Boolean);
    if (!need.length) return Promise.resolve();
    if (window.__loadScriptsOnce) return window.__loadScriptsOnce(need, 'tinnitus-export');
    return Promise.all(need.map(function (src) {
        return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
    }));
}
function yieldTick() {
    if (window.__yieldTick) return window.__yieldTick(0);
    return new Promise(function (r) { setTimeout(r, 0); });
}
function progress(p) {
    $('tnDlProg').hidden = false;
    $('tnDlBar').style.width = (p * 100).toFixed(1) + '%';
    $('tnDlPct').textContent = Math.round(p * 100) + '%';
}
function outName(base, ext) {
    try { if (window.__outputName) return window.__outputName.join(base, ext); } catch (e) { }
    return base.replace(/[\\/:*?"<>|]/g, '-') + '.' + ext;
}
function notchLabel() { return 'notch ' + S.f + ' Hz ' + fmtOct(widthOct()).replace('½', '0.5').replace('1½', '1.5') + ' oct'; }

var EXPORT_MAX_MB = 150;   // декод трека — целиком в память: час микса WAV уронил бы вкладку
async function decodeForExport(file) {
    if (file.size > EXPORT_MAX_MB * 1024 * 1024) throw Object.assign(new Error('too big'), { code: 'TN_TOO_BIG', size: file.size });
    var sr = 48000;
    if (window.AudioDecoderRobust && window.AudioDecoderRobust.robust) {
        var C = window.AudioContext || window.webkitAudioContext;
        var tmp = new C({ sampleRate: sr });
        try {
            var r = await window.AudioDecoderRobust.robust(file, tmp, { slug: SLUG });
            return r && r.buffer ? r.buffer : r;
        } finally { try { tmp.close(); } catch (e) { } }
    }
    var ab = await file.arrayBuffer();
    var OC = window.OfflineAudioContext || window.webkitOfflineAudioContext;
    return await new OC(2, 1, sr).decodeAudioData(ab);
}

/* Рендер одного файла: блоками по 2 с, та же математика, что у живого звука
   (sosProcess ≡ IIRFilterNode ≡ кривая), лимитер −1 дБFS, запись потоком —
   час WAV (≈ 690 МБ) не собирается в памяти. */
async function renderFile(job, onP) {
    var fmt = job.fmt, sr = job.sr, d = DSP.designChain({ notches: notchList(), edgeDb: S.edge ? S.edgeDb : 0, tilt: S.tilt }, sr);
    var makeup = Math.pow(10, DSP.makeupDb(d.colorSos, job.profile || null, sr) / 20);
    var stL = DSP.makeState(d.sos), stR = DSP.makeState(d.sos);
    var lim = window.MasteringLimiter.createFastLimiter(sr, 2, { ceilingDb: -1, windowMs: 20 });
    var sink = await window.OutputSink.create({ mime: fmt === 'wav' ? 'audio/wav' : 'audio/mpeg', name: 'tinnitus-notch' });
    var wav = null, enc = null;
    if (fmt === 'wav') wav = window.OutputSink.wavWriter(sink, sr, 2, 16);
    else enc = await window.MP3Encoder.encodeStream({ sampleRate: sr, channels: 2, bitrate: job.kbps || 128, slug: SLUG, accumulate: false });
    async function write(blocks) {
        for (var i = 0; i < blocks.length; i++) {
            if (wav) await wav.writeChunk(blocks[i]);
            else { var out = await enc.feed(blocks[i]); if (out && out.byteLength) await sink.write(out instanceof ArrayBuffer ? new Uint8Array(out) : out); }
        }
    }
    var total = job.frames, BLK = sr * 2, done = 0;
    var genL = job.noise ? DSP.noiseGen(job.noise, 4242) : null, genR = job.noise ? DSP.noiseGen(job.noise, 9001) : null;
    if (genL) {
        /* Секунда разгона: фильтр высокого порядка к началу файла уже в
           установившемся режиме, и первая секунда не отличается от сотой. */
        var pre = new Float32Array(sr), pr = new Float32Array(sr);
        genL.fill(pre); DSP.sosProcess(d.sos, stL, pre, pre);
        genR.fill(pr); DSP.sosProcess(d.sos, stR, pr, pr);
    }
    var fadeIn = job.noise ? sr * 3 : Math.round(sr * 0.01), fadeOut = job.noise ? sr * 5 : Math.round(sr * 0.02);
    while (done < total) {
        if (job.cancelled) throw Object.assign(new Error('cancelled'), { code: 'USER_CANCELLED' });
        var n = Math.min(BLK, total - done), L = new Float32Array(n), R = new Float32Array(n), i;
        if (genL) { genL.fill(L, n); genR.fill(R, n); }
        else {
            L.set(job.chL.subarray(done, done + n));
            R.set((job.chR || job.chL).subarray(done, done + n));
        }
        DSP.sosProcess(d.sos, stL, L, L);
        DSP.sosProcess(d.sos, stR, R, R);
        for (i = 0; i < n; i++) {
            var pos = done + i, g = makeup;
            if (pos < fadeIn) g *= pos / fadeIn;
            if (pos > total - fadeOut) g *= Math.max(0, (total - pos) / fadeOut);
            L[i] *= g; R[i] *= g;
        }
        await write(lim.push([L, R]));
        done += n;
        onP(done / total);
        await yieldTick();
    }
    var tail = lim.flush();
    await write(tail.blocks);
    var blob;
    if (wav) blob = await wav.finalize();
    else {
        var fin = await enc.finish();
        if (fin && fin.tail && fin.tail.byteLength) await sink.write(new Uint8Array(fin.tail));
        blob = window.OutputSink.prepend(await sink.finish(), fin && fin.head);
    }
    return blob;
}

async function exportClick() {
    if (EXP) return;
    var what = $('tnDlWhat').value, fmt = FMT === 'wav' ? 'wav' : 'mp3', kbps = FMT === 'mp3-320' ? 320 : 128;
    if (what === 'all' && !isPro()) { upsell('batch'); return; }
    var batch = null;
    if (what === 'all') {
        /* Папка или архив — первым await в клике: диалог выбора папки требует
           свежего жеста. */
        try { batch = await window.__batchDeliver.openBatch({ zipName: 'tinnitus-notch-' + S.f + 'Hz.zip', slug: SLUG, total: TRACKS.length }); }
        catch (e) { toast(t('export_err'), 'error'); return; }
        if (!batch) return;
    }
    EXP = { cancelled: false };
    var btn = $('tnDl'); btn.disabled = true;
    progress(0);
    stage('export', { what: what, fmt: fmt });
    var t0 = performance.now();
    try {
        await lazyScripts();
        if (what === 'all') {
            for (var i = 0; i < TRACKS.length; i++) {
                var tr = TRACKS[i];
                var buf = await decodeForExport(tr.file);
                var job = { fmt: fmt, kbps: kbps, sr: buf.sampleRate, frames: buf.length, chL: buf.getChannelData(0), chR: buf.numberOfChannels > 1 ? buf.getChannelData(1) : null, profile: tr.profile, cancelled: false };
                EXP.job = job;
                var blob = await renderFile(job, function (p) { progress((i + p) / TRACKS.length); });
                await batch.write(outName(tr.name + ' (' + notchLabel() + ')', fmt), blob);
            }
            await batch.finish();
        } else if (what === 'track') {
            var tr2 = TRACKS[CUR] || TRACKS[0];
            var buf2 = await decodeForExport(tr2.file);
            var job2 = { fmt: fmt, kbps: kbps, sr: buf2.sampleRate, frames: buf2.length, chL: buf2.getChannelData(0), chR: buf2.numberOfChannels > 1 ? buf2.getChannelData(1) : null, profile: tr2.profile, cancelled: false };
            EXP.job = job2;
            var blob2 = await renderFile(job2, progress);
            if (window.__downloadFile) await window.__downloadFile(blob2, outName(tr2.name + ' (' + notchLabel() + ')', fmt));
        } else {
            var mins = +what.slice(1), type = (S.src === 'music' || S.src === 'tab') ? 'pink' : S.src;
            var job3 = { fmt: fmt, kbps: kbps, sr: 48000, frames: 48000 * 60 * mins, noise: type, profile: noiseProfile(type), cancelled: false };
            EXP.job = job3;
            var blob3 = await renderFile(job3, progress);
            if (window.__downloadFile) await window.__downloadFile(blob3, outName(type + ' noise, ' + notchLabel() + ', ' + mins + ' min', fmt));
        }
        progress(1);
        toast(t('export_done'), 'success');
        try { if (window.__aeToolComplete) window.__aeToolComplete({ kind: 'export', what: what, fmt: FMT, f: S.f, w: widthOct(), ms: Math.round(performance.now() - t0) }); } catch (e) { }
    } catch (e) {
        var cancel = (window.__isUserCancel && window.__isUserCancel(e)) || (e && e.code === 'USER_CANCELLED');
        if (e && e.code === 'TN_TOO_BIG') {
            toast(t('export_too_big', { mb: EXPORT_MAX_MB }), 'warning');
            // Потолок — решение про память вкладки; без счётчика не узнать, упирается ли в него кто-то.
            feat('export_too_big', { what: what, fmt: fmt, mb: Math.round((e.size || 0) / 1048576) });
        } else if (!cancel) {
            toast(t('export_err'), 'error');
            try { if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'export_failed', what: what, fmt: fmt, err: String(e && (e.name || e.message) || e).slice(0, 80) }); } catch (x) { }
        }
        if (batch && batch.dispose) { try { batch.dispose(); } catch (x) { } }
    } finally {
        EXP = null; btn.disabled = false;
        setTimeout(function () { $('tnDlProg').hidden = true; }, 1200);
    }
}
$('tnDl').addEventListener('click', exportClick);
$('tnDlWhat').addEventListener('change', renderDlWhat);
$('tnDlCancel').addEventListener('click', function () { if (EXP) { EXP.cancelled = true; if (EXP.job) EXP.job.cancelled = true; } });

/* ═══ ОТЧЁТ ДЛЯ ВРАЧА (Премиум) ══════════════════════════════════════════ */
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
$('tnPdf').addEventListener('click', function () {
    if (!isPro()) { upsell('pdf'); return; }
    var go = function () {
        var s = summary(), el = document.createElement('div');
        el.className = 'tn-report';
        var dfmt;
        try { dfmt = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { dfmt = { format: function (d) { return d.toISOString().slice(0, 10); } }; }
        var weeks = [];
        for (var w = 7; w >= 0; w--) {
            var sum = 0;
            for (var dd = 0; dd < 7; dd++) { var d = new Date(); d.setDate(d.getDate() - w * 7 - dd); var r = LOG.days[dayKey(d)]; if (r) sum += r.m || 0; }
            weeks.push(Math.round(sum));
        }
        var maxW = Math.max(60, Math.max.apply(null, weeks));
        var rated = Object.keys(LOG.days).filter(function (k) { return LOG.days[k].l != null; }).sort();
        var html = '<h2>' + esc(t('rep_title')) + '</h2><div class="muted">' + esc(dfmt.format(new Date())) + ' · ' + esc(location.origin + location.pathname) + '</div>' +
            '<h3>' + esc(t('rep_profile')) + '</h3><table>' +
            '<tr><td>' + esc(t('rep_freq')) + '</td><td class="num">' + hz(S.f) + ' ' + esc(t('hz')) + '</td></tr>' +
            (S.two && S.f2 ? '<tr><td>' + esc(t('rep_freq2')) + '</td><td class="num">' + hz(S.f2) + ' ' + esc(t('hz')) + '</td></tr>' : '') +
            '<tr><td>' + esc(t('rep_width')) + '</td><td class="num">' + fmtOct(widthOct()) + ' ' + esc(t('oct')) + (S.w === 'auto' ? ' (' + esc(t('w_auto')) + ')' : '') + '</td></tr>' +
            '<tr><td>' + esc(t('rep_depth')) + '</td><td class="num">≥ ' + DSP.DEPTH_DB + ' dB</td></tr>' +
            '<tr><td>' + esc(t('rep_edge')) + '</td><td class="num">' + (S.edge ? '+' + S.edgeDb + ' dB' : '—') + '</td></tr>' +
            '<tr><td>' + esc(t('rep_tilt')) + '</td><td class="num">' + (S.tilt ? '✓' : '—') + '</td></tr>' +
            '<tr><td>' + esc(t('rep_src')) + '</td><td class="num">' + esc(t('src_' + S.src)) + '</td></tr></table>' +
            '<h3>' + esc(t('rep_matches')) + '</h3><table><tr><th>' + esc(t('rep_date')) + '</th><th class="num">' + esc(t('hz')) + '</th><th>' + esc(t('rep_stim')) + '</th><th>' + esc(t('rep_ear')) + '</th></tr>' +
            MATCHES.slice(-12).map(function (m) {
                return '<tr><td>' + esc(dfmt.format(new Date(m.t))) + (m.practice ? ' (' + esc(t('rep_practice')) + ')' : '') + '</td><td class="num">' + hz(m.f) + '</td><td>' + esc(t('stim_' + (m.stim || 'tone'))) + '</td><td>' + esc(t('ear_' + (m.ear || 'B').toLowerCase())) + '</td></tr>';
            }).join('') + '</table>' +
            (s && s.spread != null ? '<div class="muted">' + esc(t('rep_spread', { s: NF1.format(s.spread) })) + '</div>' : '') +
            '<h3>' + esc(t('rep_minutes')) + '</h3><div class="bars">' + weeks.map(function (m) { return '<i style="height:' + Math.max(1, m / maxW * 88).toFixed(0) + 'px" title="' + m + '"></i>'; }).join('') + '</div>' +
            '<div class="muted">' + esc(t('rep_minutes_d', { list: weeks.join(' · ') })) + '</div>' +
            '<h3>' + esc(t('rep_ratings')) + '</h3><table><tr><th>' + esc(t('rep_date')) + '</th><th class="num">' + esc(t('rate_loud')) + '</th><th class="num">' + esc(t('rate_annoy')) + '</th><th class="num">' + esc(t('min')) + '</th></tr>' +
            rated.slice(-20).map(function (k) { var r = LOG.days[k]; return '<tr><td>' + esc(k) + '</td><td class="num">' + r.l + '</td><td class="num">' + r.a + '</td><td class="num">' + Math.round(r.m || 0) + '</td></tr>'; }).join('') + '</table>' +
            '<p class="muted" style="margin-top:16px">' + esc(t('rep_disc')) + '</p>';
        el.innerHTML = html;
        document.body.appendChild(el);
        var p = window.__generatePDF ? window.__generatePDF({ element: el, filename: 'tinnitus-notch-report.pdf', title: t('rep_title') }) : Promise.resolve({ ok: false });
        Promise.resolve(p).then(function (r) {
            el.remove();
            if (r && r.ok) feat('pdf_report', { kb: r.kb }); else feat('pdf_report_fail', { code: r && r.code });
        });
    };
    if (window.__generatePDF) go();
    else if (window.__loadScriptsOnce && CFG.lazy && CFG.lazy.pdf) window.__loadScriptsOnce([CFG.lazy.pdf], 'report-pdf').then(go, function () { toast(t('export_err'), 'error'); });
    else toast(t('export_err'), 'error');
});

/* ═══ ДОК И КЛАВИШИ ══════════════════════════════════════════════════════ */
$('tnPlay').addEventListener('click', togglePlay);
$('tnVol').value = S.vol;
$('tnVol').addEventListener('input', function () { S.vol = +this.value; setVolume(); });
$('tnVol').addEventListener('change', saveProfile);
$('tnTimer').value = String(S.timer);
$('tnTimer').addEventListener('change', function () {
    S.timer = +this.value; saveProfile();
    if (PLAY.on) {
        /* Таймер меняют на ходу — пересчитываем конец от «сейчас». */
        PLAY.endAt = S.timer > 0 ? Date.now() + S.timer * 60000 : 0;
        var c = G.ctx, now = c.currentTime;
        G.fade.gain.cancelScheduledValues(now); G.fade.gain.setValueAtTime(1, now);
        if (S.timer > 0) { G.fade.gain.setValueAtTime(1, now + S.timer * 60 - 20); G.fade.gain.linearRampToValueAtTime(0, now + S.timer * 60); }
        mediaSession(true);
    }
    feat('timer', { m: S.timer });
});
document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
    var tag = (e.target && e.target.tagName) || '';
    if ((window.__keyOwnedByFocus ? window.__keyOwnedByFocus(e) : (/INPUT|TEXTAREA|SELECT|BUTTON/.test(tag) || (e.target && e.target.isContentEditable))) || dlg.open) return;
    if (e.code === 'Space' && e.target.closest && e.target.closest('#tnConsole')) { e.preventDefault(); togglePlay(); }
});

/* ═══ СТАРТ ══════════════════════════════════════════════════════════════ */
function init() {
    $('tnFreq').value = hz(S.f);
    syncPitchControls();
    renderSound();
    renderPro();
    renderEmpty();
    renderMeta();
    renderPlay();
    renderProgress();
    renderDlWhat();
    if (DK) {
        DK.accordion(document.querySelector('.dk-side'), { slug: SLUG });
        DK.fitDock($('tnDock'));
        DK.onTier(function () { renderPro(); renderMeta(); drawAll(); });
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(plot); else window.addEventListener('resize', resize);
    resize();
    stage('ready', { matched: S.matched ? 1 : 0, src: S.src });
}
init();
})();
